/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yaml` */
/* eslint-disable @typescript-eslint/ban-types,no-duplicate-imports */
import { DocumentNode } from 'graphql'
import gql from 'graphql-tag'
export type ChatFieldsFragment = (
  Pick<Chat, '_id' | 'professionalId' | 'clientId'>
  & { professional?: Maybe<Pick<ChatUser, 'firstName' | 'lastName'>>, client?: Maybe<Pick<ChatUser, 'firstName' | 'lastName'>>, lastMessage: Pick<LastMessage, 'message' | 'sentAt'>, messageCount: { professional: Pick<MessageCount, 'unreadMessages' | 'sent'>, client: Pick<MessageCount, 'unreadMessages' | 'sent'> } }
);

export type AuthTokenFieldsFragment = Pick<AuthToken, 'auth' | 'role' | 'expires'>;

export type InAppMessageFieldsFragment = Pick<InAppMessage, '_id' | 'name' | 'platform' | 'eventName' | 'match' | 'contentType' | 'published' | 'content' | 'createdAt' | 'updatedAt'>;

export type ProfessionalFieldsFragment = Pick<Professional, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'role' | 'gender' | 'blocked' | 'emailConfirmed' | 'mobileConfirmed' | 'notificationPreferences' | 'createdAt' | 'lastHealthPPECheck' | 'healthPPEConfirmed' | 'profileUrl' | 'tags' | 'stripePayoutEnabled' | 'stripeAccountStatus'>;

export type UserFieldsFragment = (
  Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'role' | 'gender' | 'blocked' | 'emailConfirmed' | 'mobileConfirmed' | 'notificationPreferences' | 'createdAt' | 'lastHealthPPECheck' | 'healthPPEConfirmed' | 'profileUrl' | 'tags' | 'stripePayoutEnabled' | 'stripeAccountStatus'>
  & { subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>> }
);

export type PostcodeFieldsFragment = Pick<Postcode, '_id' | 'code' | 'name' | 'region' | 'locality' | 'active' | 'subRegion' | 'featured' | 'congestion' | 'hidden'>;

export type ProfessionalProfileFieldsFragment = Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>;

export type BookingFieldsFragment = (
  Pick<Booking, '_id' | 'date' | 'status' | 'requestStatus' | 'address' | 'totalPrice' | 'totalFee' | 'totalDuration' | 'title' | 'items' | 'createdAt' | 'publishedDate' | 'cancelledDate' | 'type' | 'promoCodeDiscount' | 'payoutDrafted' | 'payoutRequired' | 'payoutDate' | 'note' | 'tags' | 'region' | 'requestExpired' | 'requestedFavouriteIds' | 'requestedProfessionalIds' | 'rejectedByIds' | 'platform' | 'payoutPercentage' | 'reviewPrompted' | 'clientNote' | 'clientPictures'>
  & { user?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'tags'>>, professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'lastHealthPPECheck' | 'healthPPEConfirmed'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>> }
  )>, clientReview?: Maybe<Pick<Review, '_id' | 'comment' | 'rating' | 'feedback' | 'wouldRebookPro'>>, professionalReview?: Maybe<Pick<Review, '_id' | 'comment' | 'rating'>>, clientDetails?: Maybe<Array<Maybe<Pick<ClientDetails, 'firstName' | 'note' | 'contactNumber' | 'accountOwner' | 'gender'>>>>, promoCode?: Maybe<(
    Pick<PromoCode, '_id' | 'promoCode'>
    & { redeemAction?: Maybe<Pick<RedeemAction, 'action'>> }
  )>, postcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region' | 'locality' | 'active' | 'subRegion' | 'featured' | 'congestion' | 'hidden'>> }
);

export type AdjustmentFieldsFragment = Pick<Adjustment, '_id' | 'bookingId' | 'professionalId' | 'note' | 'amount' | 'adjustmentType' | 'payoutDrafted' | 'createdAt' | 'payoutDate'>;

export type TreatmentFieldsFragment = (
  Pick<Treatment, '_id' | 'name' | 'tags' | 'type' | 'isOption' | 'isTreatment' | 'isPackage' | 'duration' | 'active' | 'price' | 'fee' | 'notes' | 'shortDescription' | 'regions'>
  & { prices?: Maybe<Array<Maybe<Pick<Price, 'region' | 'amount'>>>>, testPrices?: Maybe<Array<Maybe<Pick<Price, 'region' | 'amount'>>>>, fees?: Maybe<Array<Maybe<Pick<Price, 'region' | 'amount'>>>>, info?: Maybe<Array<Maybe<Pick<TreatmentInfo, 'title' | 'body'>>>>, optionGroups?: Maybe<Array<Maybe<(
    Pick<TreatmentOptionGroup, 'name' | 'multiSelect' | 'defaultIndex' | 'optionIds'>
    & { options?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'price' | 'fee' | 'name' | 'duration' | 'isOption' | 'isTreatment' | 'active'>>>> }
  )>>> }
);

export type ProfessionalAnalyticFieldsFragment = (
  Pick<ProfessionalAnalytic, '_id' | 'firstName' | 'lastName'>
  & { earnings: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, hours: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, averageReview: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, reviewCount: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, numberOfBookings: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, favourites: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, repeatCustomer: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, droppedBookings: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'> }
);

export type CategoryFieldsFragment = (
  Pick<Category, '_id' | 'name' | 'active' | 'treatmentIds' | 'regions' | 'order' | 'slug' | 'description'>
  & { images?: Maybe<Array<Maybe<Pick<CategoryImage, 'image' | 'text'>>>> }
);

export type PageFieldsFragment = Pick<Page, '_id' | 'title' | 'body' | 'type'>;

export type GiftCardFieldsFragment = (
  Pick<GiftCard, '_id' | 'type' | 'recipientEmail' | 'fromEmail' | 'recipientName' | 'fromId' | 'fromName' | 'note' | 'sentTo' | 'amount' | 'redeemedById' | 'code' | 'blocked' | 'batched' | 'recipientAddress' | 'createdAt' | 'treatmentId'>
  & { treatment?: Maybe<Pick<Treatment, 'name'>> }
);

export type CardFieldsFragment = Pick<Card, '_id' | 'setDefaultAt' | 'userId' | 'stripePaymentMethod' | 'expMonth' | 'expYear' | 'lastFourDigits' | 'brand' | 'blocked' | 'blockedReason'>;

export type FavouriteFieldsFragment = (
  Pick<Favourite, '_id'>
  & { professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'gender'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>> }
  )> }
);

export type TransactionFieldsFragment = Pick<Transaction, '_id' | 'createdAt' | 'userId' | 'adminId' | 'orderId' | 'sourceId' | 'sourceType' | 'transactionType' | 'amount' | 'note' | 'status' | 'orderType' | 'category'>;

export type ReviewFieldsFragment = (
  Pick<Review, '_id' | 'professionalId' | 'bookingId' | 'comment' | 'feedback' | 'createdAt' | 'flagged' | 'featured' | 'rating' | 'reviewer' | 'hidden'>
  & { user?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName'>>, professional?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName'>>, booking?: Maybe<Pick<Booking, '_id'>> }
);

export type AddressFieldsFragment = Pick<UserAddress, '_id' | 'label' | 'firstLine' | 'secondLine' | 'city' | 'postalCode' | 'note' | 'setDefaultAt' | 'userId'>;

export type ProfessionalApplicationFieldsFragment = (
  Pick<ProfessionalApplication, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'postalCode' | 'gender' | 'city' | 'careerStartDate' | 'website' | 'instagram' | 'categories' | 'old_qualifications' | 'employmentHistory' | 'careerHighlights' | 'verified' | 'status' | 'old_documents' | 'createdAt' | 'verifiedDate' | 'insuranceExpiryDate' | 'note' | 'userId' | 'referral' | 'referralName' | 'interviewDate' | 'bio' | 'bookingsPerWeek' | 'currentSituation' | 'currentSituationOther'>
  & { qualifications?: Maybe<Array<Maybe<(
    Pick<Qualification, 'title' | 'dateObtained'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, documents?: Maybe<Array<Maybe<(
    Pick<ApplicationDocument, 'title' | 'expiryDate' | 'status' | 'dateAdded'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, feedback?: Maybe<Array<Maybe<Pick<ApplicationFeedback, 'comment' | 'createdAt'>>>> }
);

export type PayoutFieldsFragment = (
  Pick<Payout, '_id' | 'professionalId' | 'status' | 'stripeDueDate' | 'createdAt' | 'amount' | 'transferredAmount'>
  & { professional?: Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName' | 'stripeAccountStatus' | 'stripeConnectedAccount'>>, items?: Maybe<Array<Maybe<Pick<PayoutItem, 'bookingId' | 'adjustmentId' | 'amount' | 'date' | 'note' | 'type'>>>> }
);

export type FindOrCreateChatMutationVariables = Exact<{
  professionalId?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
}>;

export type FindOrCreateChatMutation = { findOrCreateChat: (
  Pick<Chat, '_id' | 'professionalId' | 'clientId'>
  & { professional?: Maybe<Pick<ChatUser, 'firstName' | 'lastName'>>, client?: Maybe<Pick<ChatUser, 'firstName' | 'lastName'>>, lastMessage: Pick<LastMessage, 'message' | 'sentAt'>, messageCount: { professional: Pick<MessageCount, 'unreadMessages' | 'sent'>, client: Pick<MessageCount, 'unreadMessages' | 'sent'> } }
) };

export type LoginWithEmailAndPasswordQueryVariables = Exact<{
  emailAddress?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
}>;

export type LoginWithEmailAndPasswordQuery = { loginWithEmailAndPassword?: Maybe<{ authToken?: Maybe<Pick<AuthToken, 'auth' | 'role' | 'expires'>>, user?: Maybe<(
  Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'role' | 'gender' | 'blocked' | 'emailConfirmed' | 'mobileConfirmed' | 'notificationPreferences' | 'createdAt' | 'lastHealthPPECheck' | 'healthPPEConfirmed' | 'profileUrl' | 'tags' | 'stripePayoutEnabled' | 'stripeAccountStatus'>
  & { subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>> }
)> }> };

export type VerifyMobileAndSignInMutationVariables = Exact<{
  mobile?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
}>;

export type VerifyMobileAndSignInMutation = { verifyMobileAndSignIn?: Maybe<{ authToken?: Maybe<Pick<AuthToken, 'auth' | 'role' | 'expires'>>, user?: Maybe<(
  Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'role' | 'gender' | 'blocked' | 'emailConfirmed' | 'mobileConfirmed' | 'notificationPreferences' | 'createdAt' | 'lastHealthPPECheck' | 'healthPPEConfirmed' | 'profileUrl' | 'tags' | 'stripePayoutEnabled' | 'stripeAccountStatus'>
  & { subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>> }
)> }> };

export type SendMobileVerificationQueryVariables = Exact<{
  mobile?: InputMaybe<Scalars['String']>;
  silent?: InputMaybe<Scalars['Boolean']>;
}>;

export type SendMobileVerificationQuery = { sendMobileVerification?: Maybe<{ authToken?: Maybe<Pick<AuthToken, 'auth' | 'role' | 'expires'>> }> };

export type CheckBlockedUserQueryVariables = Exact<{ [key: string]: never; }>;

export type CheckBlockedUserQuery = Pick<Query, 'checkBlockedUser'>;

export type AppVerQueryVariables = Exact<{ [key: string]: never; }>;

export type AppVerQuery = { appVer?: Maybe<Pick<AppVersion, 'minConsumerAppVer' | 'minProAppVer'>> };

export type CreateSuperAdminUserMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  emailAddress: Scalars['String'];
  password: Scalars['String'];
  mobile: Scalars['String'];
}>;

export type CreateSuperAdminUserMutation = Pick<Mutation, 'createSuperAdminUser'>;

export type BookingsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type BookingsQuery = { bookings?: Maybe<Array<Maybe<(
  Pick<Booking, '_id' | 'date' | 'status' | 'requestStatus' | 'address' | 'totalPrice' | 'totalFee' | 'totalDuration' | 'title' | 'items' | 'createdAt' | 'publishedDate' | 'cancelledDate' | 'type' | 'promoCodeDiscount' | 'payoutDrafted' | 'payoutRequired' | 'payoutDate' | 'note' | 'tags' | 'region' | 'requestExpired' | 'requestedFavouriteIds' | 'requestedProfessionalIds' | 'rejectedByIds' | 'platform' | 'payoutPercentage' | 'reviewPrompted' | 'clientNote' | 'clientPictures'>
  & { requestedProfessionals?: Maybe<Array<Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName'>>>>, user?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'tags'>>, professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'lastHealthPPECheck' | 'healthPPEConfirmed'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>> }
  )>, clientReview?: Maybe<Pick<Review, '_id' | 'comment' | 'rating' | 'feedback' | 'wouldRebookPro'>>, professionalReview?: Maybe<Pick<Review, '_id' | 'comment' | 'rating'>>, clientDetails?: Maybe<Array<Maybe<Pick<ClientDetails, 'firstName' | 'note' | 'contactNumber' | 'accountOwner' | 'gender'>>>>, promoCode?: Maybe<(
    Pick<PromoCode, '_id' | 'promoCode'>
    & { redeemAction?: Maybe<Pick<RedeemAction, 'action'>> }
  )>, postcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region' | 'locality' | 'active' | 'subRegion' | 'featured' | 'congestion' | 'hidden'>> }
)>>> };

export type BookingQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type BookingQuery = { booking?: Maybe<(
  Pick<Booking, '_id' | 'date' | 'status' | 'requestStatus' | 'address' | 'totalPrice' | 'totalFee' | 'totalDuration' | 'title' | 'items' | 'createdAt' | 'publishedDate' | 'cancelledDate' | 'type' | 'promoCodeDiscount' | 'payoutDrafted' | 'payoutRequired' | 'payoutDate' | 'note' | 'tags' | 'region' | 'requestExpired' | 'requestedFavouriteIds' | 'requestedProfessionalIds' | 'rejectedByIds' | 'platform' | 'payoutPercentage' | 'reviewPrompted' | 'clientNote' | 'clientPictures'>
  & { requestedProfessionals?: Maybe<Array<Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName'>>>>, user?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'tags'>>, professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'lastHealthPPECheck' | 'healthPPEConfirmed'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>> }
  )>, clientReview?: Maybe<Pick<Review, '_id' | 'comment' | 'rating' | 'feedback' | 'wouldRebookPro'>>, professionalReview?: Maybe<Pick<Review, '_id' | 'comment' | 'rating'>>, clientDetails?: Maybe<Array<Maybe<Pick<ClientDetails, 'firstName' | 'note' | 'contactNumber' | 'accountOwner' | 'gender'>>>>, promoCode?: Maybe<(
    Pick<PromoCode, '_id' | 'promoCode'>
    & { redeemAction?: Maybe<Pick<RedeemAction, 'action'>> }
  )>, postcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region' | 'locality' | 'active' | 'subRegion' | 'featured' | 'congestion' | 'hidden'>> }
)> };

export type GetChatAuthTokenQueryVariables = Exact<{
  _id: Scalars['String'];
  validUntil: Scalars['Date'];
}>;

export type GetChatAuthTokenQuery = Pick<Query, 'getChatAuthToken'>;

export type AddOrUpdateBookingMutationVariables = Exact<{
  data?: InputMaybe<AdminBookingInput>;
}>;

export type AddOrUpdateBookingMutation = { addOrUpdateBooking?: Maybe<(
  Pick<Booking, '_id' | 'date' | 'status' | 'requestStatus' | 'address' | 'totalPrice' | 'totalFee' | 'totalDuration' | 'title' | 'items' | 'createdAt' | 'publishedDate' | 'cancelledDate' | 'type' | 'promoCodeDiscount' | 'payoutDrafted' | 'payoutRequired' | 'payoutDate' | 'note' | 'tags' | 'region' | 'requestExpired' | 'requestedFavouriteIds' | 'requestedProfessionalIds' | 'rejectedByIds' | 'platform' | 'payoutPercentage' | 'reviewPrompted' | 'clientNote' | 'clientPictures'>
  & { user?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'tags'>>, professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'lastHealthPPECheck' | 'healthPPEConfirmed'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>> }
  )>, clientReview?: Maybe<Pick<Review, '_id' | 'comment' | 'rating' | 'feedback' | 'wouldRebookPro'>>, professionalReview?: Maybe<Pick<Review, '_id' | 'comment' | 'rating'>>, clientDetails?: Maybe<Array<Maybe<Pick<ClientDetails, 'firstName' | 'note' | 'contactNumber' | 'accountOwner' | 'gender'>>>>, promoCode?: Maybe<(
    Pick<PromoCode, '_id' | 'promoCode'>
    & { redeemAction?: Maybe<Pick<RedeemAction, 'action'>> }
  )>, postcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region' | 'locality' | 'active' | 'subRegion' | 'featured' | 'congestion' | 'hidden'>> }
)> };

export type UpdateBookingStatusMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type UpdateBookingStatusMutation = Pick<Mutation, 'updateBookingStatus'>;

export type AcceptBookingMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  ignoreConflictingBookings?: InputMaybe<Scalars['Boolean']>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type AcceptBookingMutation = Pick<Mutation, 'acceptBooking'>;

export type PublishBookingMutationVariables = Exact<{
  data?: InputMaybe<BookingInput>;
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
}>;

export type PublishBookingMutation = { publishBooking?: Maybe<(
  Pick<Booking, '_id' | 'date' | 'status' | 'requestStatus' | 'address' | 'totalPrice' | 'totalFee' | 'totalDuration' | 'title' | 'items' | 'createdAt' | 'publishedDate' | 'cancelledDate' | 'type' | 'promoCodeDiscount' | 'payoutDrafted' | 'payoutRequired' | 'payoutDate' | 'note' | 'tags' | 'region' | 'requestExpired' | 'requestedFavouriteIds' | 'requestedProfessionalIds' | 'rejectedByIds' | 'platform' | 'payoutPercentage' | 'reviewPrompted' | 'clientNote' | 'clientPictures'>
  & { user?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'tags'>>, professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'lastHealthPPECheck' | 'healthPPEConfirmed'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>> }
  )>, clientReview?: Maybe<Pick<Review, '_id' | 'comment' | 'rating' | 'feedback' | 'wouldRebookPro'>>, professionalReview?: Maybe<Pick<Review, '_id' | 'comment' | 'rating'>>, clientDetails?: Maybe<Array<Maybe<Pick<ClientDetails, 'firstName' | 'note' | 'contactNumber' | 'accountOwner' | 'gender'>>>>, promoCode?: Maybe<(
    Pick<PromoCode, '_id' | 'promoCode'>
    & { redeemAction?: Maybe<Pick<RedeemAction, 'action'>> }
  )>, postcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region' | 'locality' | 'active' | 'subRegion' | 'featured' | 'congestion' | 'hidden'>> }
)> };

export type CreateOrUpdateInAppMessageMutationVariables = Exact<{
  data: InAppMessageInput;
}>;

export type CreateOrUpdateInAppMessageMutation = { createOrUpdateInAppMessage?: Maybe<Pick<InAppMessage, '_id' | 'name' | 'platform' | 'eventName' | 'match' | 'contentType' | 'published' | 'content' | 'createdAt' | 'updatedAt'>> };

export type NotifyRequestedProfessionalsMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type NotifyRequestedProfessionalsMutation = Pick<Mutation, 'notifyRequestedProfessionals'>;

export type CancelBookingMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type CancelBookingMutation = Pick<Mutation, 'cancelBooking'>;

export type AdjustmentsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSONObject']>;
}>;

export type AdjustmentsQuery = { adjustments?: Maybe<Array<Maybe<Pick<Adjustment, '_id' | 'bookingId' | 'professionalId' | 'note' | 'amount' | 'adjustmentType' | 'payoutDrafted' | 'createdAt' | 'payoutDate'>>>> };

export type CreateAdjustmentMutationVariables = Exact<{
  data?: InputMaybe<AdjustmentInput>;
}>;

export type CreateAdjustmentMutation = { createAdjustment?: Maybe<Pick<Adjustment, '_id' | 'bookingId' | 'professionalId' | 'note' | 'amount' | 'adjustmentType' | 'payoutDrafted' | 'createdAt' | 'payoutDate'>> };

export type GetTreatmentsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type GetTreatmentsQuery = { getTreatments?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'name' | 'type' | 'isOption' | 'isTreatment' | 'isPackage' | 'active' | 'notes' | 'regions'>>>> };

export type GetTreatmentQueryVariables = Exact<{
  _id: Scalars['String'];
  getOptions?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['String']>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type GetTreatmentQuery = { getTreatment?: Maybe<(
  Pick<Treatment, '_id' | 'name' | 'tags' | 'type' | 'isOption' | 'isTreatment' | 'isPackage' | 'duration' | 'active' | 'price' | 'fee' | 'notes' | 'shortDescription' | 'regions'>
  & { prices?: Maybe<Array<Maybe<Pick<Price, 'region' | 'amount'>>>>, testPrices?: Maybe<Array<Maybe<Pick<Price, 'region' | 'amount'>>>>, fees?: Maybe<Array<Maybe<Pick<Price, 'region' | 'amount'>>>>, info?: Maybe<Array<Maybe<Pick<TreatmentInfo, 'title' | 'body'>>>>, optionGroups?: Maybe<Array<Maybe<(
    Pick<TreatmentOptionGroup, 'name' | 'multiSelect' | 'defaultIndex' | 'optionIds'>
    & { options?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'price' | 'fee' | 'name' | 'duration' | 'isOption' | 'isTreatment' | 'active'>>>> }
  )>>> }
)> };

export type AddOrUpdateTreatmentMutationVariables = Exact<{
  data: TreatmentInput;
}>;

export type AddOrUpdateTreatmentMutation = { addOrUpdateTreatment?: Maybe<Pick<Treatment, '_id' | 'name'>> };

export type GetProfessionalsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type GetProfessionalsQuery = { getProfessionals?: Maybe<Array<Maybe<(
  Pick<Professional, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'role' | 'gender' | 'blocked' | 'emailConfirmed' | 'mobileConfirmed' | 'notificationPreferences' | 'createdAt' | 'lastHealthPPECheck' | 'healthPPEConfirmed' | 'profileUrl' | 'tags' | 'stripePayoutEnabled' | 'stripeAccountStatus'>
  & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>> }
)>>> };

export type GetProfessionalsAnalyticsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type GetProfessionalsAnalyticsQuery = { getProfessionalsAnalytics?: Maybe<Array<Maybe<(
  Pick<ProfessionalAnalytic, '_id' | 'firstName' | 'lastName'>
  & { earnings: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, hours: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, averageReview: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, reviewCount: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, numberOfBookings: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, favourites: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, repeatCustomer: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, droppedBookings: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'> }
)>>> };

export type GetProfessionalAnalyticsQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  periods?: InputMaybe<Array<InputMaybe<PeriodsInput>> | InputMaybe<PeriodsInput>>;
}>;

export type GetProfessionalAnalyticsQuery = { getProfessionalAnalytics?: Maybe<(
  Pick<ProfessionalAnalytic, '_id' | 'firstName' | 'lastName'>
  & { earnings: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, hours: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, averageReview: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, reviewCount: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, numberOfBookings: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, favourites: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, repeatCustomer: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'>, droppedBookings: Pick<PeriodData, 'currentPeriod' | 'previousPeriod'> }
)> };

export type GetProfessionalQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type GetProfessionalQuery = { getProfessional?: Maybe<(
  Pick<Professional, 'acceptedTermsPA' | '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'role' | 'gender' | 'blocked' | 'emailConfirmed' | 'mobileConfirmed' | 'notificationPreferences' | 'createdAt' | 'lastHealthPPECheck' | 'healthPPEConfirmed' | 'profileUrl' | 'tags' | 'stripePayoutEnabled' | 'stripeAccountStatus'>
  & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'treatmentIds' | 'disabledOptionIds' | 'postcodeIds' | 'acceptedTermsPA' | 'defaultTransportMode' | 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'treatmentTypes'>> }
)> };

export type FindInstantProfessionalsQueryVariables = Exact<{
  matchingParams?: InputMaybe<InstantMatchingParams>;
  days?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  proProfileFilter?: InputMaybe<Scalars['JSONObject']>;
}>;

export type FindInstantProfessionalsQuery = { findInstantProfessionals?: Maybe<Array<Maybe<(
  Pick<AvailableProfessionals, 'day'>
  & { professionals?: Maybe<Array<Maybe<(
    Pick<InstantProfessional, 'day' | 'availableTimeSlots' | 'bookedTimesSlots'>
    & { professional?: Maybe<(
      Pick<Professional, '_id' | 'firstName' | 'lastName' | 'tags'>
      & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'featured' | 'updatedAvailabilityAt' | 'numberOfBookings'>> }
    )> }
  )>>> }
)>>> };

export type GetProfessionalAvailabilityQueryVariables = Exact<{
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JSONObject']>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type GetProfessionalAvailabilityQuery = { getProfessionalAvailability?: Maybe<Array<Maybe<Pick<ProfessionalAvailability, 'day' | 'status' | 'times' | 'treatmentIds' | 'postcodeIds' | 'transportMode'>>>> };

export type RemoveProfessionalAvailabilityMutationVariables = Exact<{
  filter?: InputMaybe<ProfessionalAvailabilityInput>;
}>;

export type RemoveProfessionalAvailabilityMutation = Pick<Mutation, 'removeProfessionalAvailability'>;

export type GetProfessionalAgendasQueryVariables = Exact<{
  days?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type GetProfessionalAgendasQuery = { getProfessionalAgendas?: Maybe<Array<Maybe<(
  Pick<ProfessionalAgenda, 'day'>
  & { events?: Maybe<Array<Maybe<Pick<DiaryEvent, 'date' | 'title' | 'color' | 'bookingId' | 'startHour' | 'durationHours' | 'outerCode' | 'type'>>>>, availability?: Maybe<(
    Pick<ProfessionalAvailability, 'day' | 'status' | 'times' | 'treatmentIds' | 'postcodeIds' | 'transportMode' | 'updatedAt'>
    & { treatments?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'name'>>>>, postcodes?: Maybe<Array<Maybe<Pick<Postcode, 'code'>>>> }
  )>, history?: Maybe<Array<Maybe<(
    Pick<ProfessionalAvailability, 'day' | 'status' | 'times' | 'treatmentIds' | 'postcodeIds' | 'transportMode' | 'updatedAt'>
    & { treatments?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'name'>>>>, postcodes?: Maybe<Array<Maybe<Pick<Postcode, 'code'>>>> }
  )>>> }
)>>> };

export type FindRequestableProfessionalsQueryVariables = Exact<{
  matchingParams: MatchingParams;
  extendToSubRegion: Scalars['Boolean'];
  admin: Scalars['JSONObject'];
}>;

export type FindRequestableProfessionalsQuery = { findRequestableProfessionals?: Maybe<Array<Maybe<(
  Pick<RequestMatchResult, '_id'>
  & { availabilityStatus?: Maybe<Pick<AvailabiltiyStatus, 'treatments' | 'postcode' | 'time' | 'bookingClash' | 'status' | 'isFavourite' | 'subRegionOnly'>>, professionalProfile?: Maybe<(
    Pick<ProfileMatch, 'userId' | 'favouriteCount' | 'reviewCount' | 'averageReview' | 'numberOfBookings' | 'updatedAvailabilityAt'>
    & { user?: Maybe<Pick<UserDetails, '_id' | 'firstName' | 'lastName' | 'mobile'>> }
  )> }
)>>> };

export type CheckProfessionalAvailabilityQueryVariables = Exact<{
  matchingParams: InstantMatchingParams;
  professionalId: Scalars['String'];
  bookingId?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
}>;

export type CheckProfessionalAvailabilityQuery = Pick<Query, 'checkProfessionalAvailability'>;

export type ExtendRequestToProfessionalMutationVariables = Exact<{
  professionalId?: InputMaybe<Scalars['String']>;
  bookingId?: InputMaybe<Scalars['String']>;
  availabilityStatus?: InputMaybe<Scalars['JSONObject']>;
}>;

export type ExtendRequestToProfessionalMutation = { extendRequestToProfessional?: Maybe<Pick<Booking, '_id' | 'requestedProfessionalIds'>> };

export type AddOrUpdateProfessionalUserMutationVariables = Exact<{
  data?: InputMaybe<ProfessionalInput>;
}>;

export type AddOrUpdateProfessionalUserMutation = { addOrUpdateProfessionalUser?: Maybe<(
  Pick<Professional, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'role' | 'gender' | 'blocked' | 'emailConfirmed' | 'mobileConfirmed' | 'notificationPreferences' | 'createdAt' | 'lastHealthPPECheck' | 'healthPPEConfirmed' | 'profileUrl' | 'tags' | 'stripePayoutEnabled' | 'stripeAccountStatus'>
  & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>> }
)> };

export type CategoriesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
}>;

export type CategoriesQuery = { categories?: Maybe<Array<Maybe<(
  Pick<Category, '_id' | 'name' | 'active' | 'treatmentIds' | 'regions' | 'order' | 'slug' | 'description'>
  & { images?: Maybe<Array<Maybe<Pick<CategoryImage, 'image' | 'text'>>>> }
)>>> };

export type CategoryStubsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
}>;

export type CategoryStubsQuery = { categories?: Maybe<Array<Maybe<Pick<Category, '_id' | 'name'>>>> };

export type CategoryQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type CategoryQuery = { category?: Maybe<(
  Pick<Category, '_id' | 'name' | 'active' | 'treatmentIds' | 'regions' | 'order' | 'slug' | 'description'>
  & { images?: Maybe<Array<Maybe<Pick<CategoryImage, 'image' | 'text'>>>> }
)> };

export type SaveCategoryMutationVariables = Exact<{
  data: CategoryInput;
}>;

export type SaveCategoryMutation = { saveCategory?: Maybe<(
  Pick<Category, '_id' | 'name' | 'active' | 'treatmentIds' | 'regions' | 'order' | 'slug' | 'description'>
  & { images?: Maybe<Array<Maybe<Pick<CategoryImage, 'image' | 'text'>>>> }
)> };

export type GetPostcodesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type GetPostcodesQuery = { getPostcodes?: Maybe<Array<Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region' | 'locality' | 'active' | 'subRegion' | 'featured' | 'congestion' | 'hidden'>>>> };

export type GetPostcodeQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type GetPostcodeQuery = { getPostcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region' | 'locality' | 'active' | 'subRegion' | 'featured' | 'congestion' | 'hidden'>> };

export type CreateOrUpdatePostcodeMutationVariables = Exact<{
  data?: InputMaybe<PostcodeInput>;
}>;

export type CreateOrUpdatePostcodeMutation = { createOrUpdatePostcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region' | 'locality' | 'active' | 'subRegion' | 'featured' | 'congestion' | 'hidden'>> };

export type CheckPostcodeInServiceAreaQueryVariables = Exact<{
  postcode?: InputMaybe<Scalars['String']>;
}>;

export type CheckPostcodeInServiceAreaQuery = { checkPostcodeInServiceArea?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region' | 'locality' | 'active' | 'subRegion' | 'featured' | 'congestion' | 'hidden'>> };

export type PromoCodesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type PromoCodesQuery = { promoCodes?: Maybe<Array<Maybe<Pick<PromoCode, '_id' | 'promoCode' | 'title' | 'active' | 'value' | 'discountType' | 'startDate' | 'expiryDate' | 'createdAt' | 'useCount' | 'tags'>>>> };

export type PromoCodeQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type PromoCodeQuery = { promoCode?: Maybe<(
  Pick<PromoCode, '_id' | 'promoCode' | 'title' | 'description' | 'active' | 'discountType' | 'value' | 'campaign' | 'startDate' | 'expiryDate' | 'tags' | 'featured'>
  & { limits?: Maybe<(
    Pick<PromoLimits, 'excludedTreatmentTypes' | 'includedTreatmentTypes' | 'bookingsCount' | 'bookingsCountCondition' | 'minTreatmentCount' | 'minBasketValue' | 'perCustomerCap' | 'totalAvailable' | 'days' | 'hours' | 'regions'>
    & { availableTo?: Maybe<Array<Maybe<Pick<User, '_id' | 'firstName' | 'lastName'>>>>, unavailableTo?: Maybe<Array<Maybe<Pick<User, '_id' | 'firstName' | 'lastName'>>>>, excludedTreatments?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'name'>>>>, includedTreatments?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'name'>>>> }
  )> }
)> };

export type SavePromoCodeMutationVariables = Exact<{
  data?: InputMaybe<PromoCodeInput>;
}>;

export type SavePromoCodeMutation = { savePromoCode?: Maybe<Pick<PromoCode, '_id'>> };

export type BatchCreatePromoCodeMutationVariables = Exact<{
  data?: InputMaybe<PromoCodeInput>;
  batchData?: InputMaybe<PromoCodeBatchData>;
}>;

export type BatchCreatePromoCodeMutation = { batchCreatePromoCode?: Maybe<Array<Maybe<Pick<PromoCode, '_id' | 'promoCode'>>>> };

export type CheckPromoCodeQueryVariables = Exact<{
  promoCode: Scalars['String'];
  booking?: InputMaybe<PromoBookingInput>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type CheckPromoCodeQuery = { checkPromoCode?: Maybe<(
  Pick<PromoCodeCheck, 'canApply' | 'promoCodeDiscount'>
  & { data?: Maybe<Pick<PromoCodeExists, '_id' | 'promoCode' | 'value' | 'discountType'>>, reasons?: Maybe<Array<Maybe<Pick<PromoCodeErrorReasons, 'reason' | 'value'>>>> }
)> };

export type GiftCardsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type GiftCardsQuery = { giftCards?: Maybe<Array<Maybe<(
  Pick<GiftCard, '_id' | 'type' | 'recipientEmail' | 'fromEmail' | 'recipientName' | 'fromId' | 'fromName' | 'note' | 'sentTo' | 'amount' | 'redeemedById' | 'code' | 'blocked' | 'batched' | 'recipientAddress' | 'createdAt' | 'treatmentId'>
  & { treatment?: Maybe<Pick<Treatment, 'name'>> }
)>>> };

export type GiftCardQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type GiftCardQuery = { giftCard?: Maybe<(
  Pick<GiftCard, '_id' | 'type' | 'recipientEmail' | 'fromEmail' | 'recipientName' | 'fromId' | 'fromName' | 'note' | 'sentTo' | 'amount' | 'redeemedById' | 'code' | 'blocked' | 'batched' | 'recipientAddress' | 'createdAt' | 'treatmentId'>
  & { treatment?: Maybe<Pick<Treatment, 'name'>> }
)> };

export type AddOrUpdateGiftCardMutationVariables = Exact<{
  data: GiftCardInput;
}>;

export type AddOrUpdateGiftCardMutation = { addOrUpdateGiftCard?: Maybe<Pick<GiftCard, '_id'>> };

export type RedeemGiftCardMutationVariables = Exact<{
  giftCardCode?: InputMaybe<Scalars['String']>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type RedeemGiftCardMutation = { redeemGiftCard?: Maybe<Pick<GiftCard, 'amount'>> };

export type RequestCardSetupIntentQueryVariables = Exact<{ [key: string]: never; }>;

export type RequestCardSetupIntentQuery = Pick<Query, 'requestCardSetupIntent'>;

export type CardsQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type CardsQuery = { cards?: Maybe<Array<Maybe<Pick<Card, '_id' | 'setDefaultAt' | 'userId' | 'stripePaymentMethod' | 'expMonth' | 'expYear' | 'lastFourDigits' | 'brand' | 'blocked' | 'blockedReason'>>>> };

export type AddCardMutationVariables = Exact<{
  token?: InputMaybe<CardToken>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type AddCardMutation = { addCard?: Maybe<Pick<Card, '_id' | 'setDefaultAt' | 'userId' | 'stripePaymentMethod' | 'expMonth' | 'expYear' | 'lastFourDigits' | 'brand' | 'blocked' | 'blockedReason'>> };

export type RemoveCardMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type RemoveCardMutation = { removeCard?: Maybe<Pick<Card, '_id'>> };

export type UpdateDefaultCardMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  setDefaultAt?: InputMaybe<Scalars['String']>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type UpdateDefaultCardMutation = { updateDefaultCard?: Maybe<Pick<Card, '_id'>> };

export type UpdateCardBlockedMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  blocked?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateCardBlockedMutation = { updateCardBlocked?: Maybe<Pick<Card, '_id' | 'setDefaultAt' | 'userId' | 'stripePaymentMethod' | 'expMonth' | 'expYear' | 'lastFourDigits' | 'brand' | 'blocked' | 'blockedReason'>> };

export type CreateTransactionMutationVariables = Exact<{
  data?: InputMaybe<TransactionInput>;
}>;

export type CreateTransactionMutation = { createTransaction?: Maybe<Pick<Transaction, '_id' | 'createdAt' | 'userId' | 'adminId' | 'orderId' | 'sourceId' | 'sourceType' | 'transactionType' | 'amount' | 'note' | 'status' | 'orderType' | 'category'>> };

export type BalanceQueryVariables = Exact<{
  order?: InputMaybe<OrderDetails>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type BalanceQuery = Pick<Query, 'balance'>;

export type CompletePaymentMutationVariables = Exact<{
  order: Order;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type CompletePaymentMutation = { completePayment?: Maybe<Pick<PaymentCompleteResponse, 'isPaid'>> };

export type PrepareForPaymentQueryVariables = Exact<{
  orderInfo: OrderInfo;
}>;

export type PrepareForPaymentQuery = { prepareForPayment: Pick<PreparePaymentResponse, 'clientSecret' | 'paymentIntentId'> };

export type RequestRefundMutationVariables = Exact<{
  refund: Refund;
}>;

export type RequestRefundMutation = Pick<Mutation, 'requestRefund'>;

export type PayoutsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type PayoutsQuery = { payouts?: Maybe<Array<Maybe<(
  Pick<Payout, '_id' | 'professionalId' | 'status' | 'stripeDueDate' | 'createdAt' | 'amount' | 'transferredAmount'>
  & { professional?: Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName' | 'stripeAccountStatus' | 'stripeConnectedAccount'>>, items?: Maybe<Array<Maybe<Pick<PayoutItem, 'bookingId' | 'adjustmentId' | 'amount' | 'date' | 'note' | 'type'>>>> }
)>>> };

export type ProfessionalPayoutsQueryVariables = Exact<{
  admin: AdminPayoutsInput;
}>;

export type ProfessionalPayoutsQuery = { professionalPayouts?: Maybe<Array<Maybe<(
  Pick<Payout, '_id' | 'professionalId' | 'status' | 'stripeDueDate' | 'createdAt' | 'amount' | 'transferredAmount'>
  & { professional?: Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName' | 'stripeAccountStatus' | 'stripeConnectedAccount'>>, items?: Maybe<Array<Maybe<Pick<PayoutItem, 'bookingId' | 'adjustmentId' | 'amount' | 'date' | 'note' | 'type'>>>> }
)>>> };

export type DraftPayoutsMutationVariables = Exact<{
  buffer?: InputMaybe<Scalars['Int']>;
}>;

export type DraftPayoutsMutation = { draftPayouts?: Maybe<Array<Maybe<(
  Pick<Payout, '_id' | 'professionalId' | 'status' | 'stripeDueDate' | 'createdAt' | 'amount' | 'transferredAmount'>
  & { professional?: Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName' | 'stripeAccountStatus' | 'stripeConnectedAccount'>>, items?: Maybe<Array<Maybe<Pick<PayoutItem, 'bookingId' | 'adjustmentId' | 'amount' | 'date' | 'note' | 'type'>>>> }
)>>> };

export type TransferDraftedPayoutsMutationVariables = Exact<{ [key: string]: never; }>;

export type TransferDraftedPayoutsMutation = { transferDraftedPayouts?: Maybe<(
  Pick<PayoutsAndErrors, 'errors'>
  & { payouts?: Maybe<Array<Maybe<(
    Pick<Payout, '_id' | 'professionalId' | 'status' | 'stripeDueDate' | 'createdAt' | 'amount' | 'transferredAmount'>
    & { professional?: Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName' | 'stripeAccountStatus' | 'stripeConnectedAccount'>>, items?: Maybe<Array<Maybe<Pick<PayoutItem, 'bookingId' | 'adjustmentId' | 'amount' | 'date' | 'note' | 'type'>>>> }
  )>>> }
)> };

export type UsersQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type UsersQuery = { users?: Maybe<Array<Maybe<(
  Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'role' | 'gender' | 'blocked' | 'emailConfirmed' | 'mobileConfirmed' | 'notificationPreferences' | 'createdAt' | 'lastHealthPPECheck' | 'healthPPEConfirmed' | 'profileUrl' | 'tags' | 'stripePayoutEnabled' | 'stripeAccountStatus'>
  & { subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>> }
)>>> };

export type UserQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type UserQuery = { user?: Maybe<(
  Pick<User, 'acceptedTermsCA' | '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'role' | 'gender' | 'blocked' | 'emailConfirmed' | 'mobileConfirmed' | 'notificationPreferences' | 'createdAt' | 'lastHealthPPECheck' | 'healthPPEConfirmed' | 'profileUrl' | 'tags' | 'stripePayoutEnabled' | 'stripeAccountStatus'>
  & { subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>> }
)> };

export type SaveUserMutationVariables = Exact<{
  data?: InputMaybe<UserInput>;
}>;

export type SaveUserMutation = { saveUser?: Maybe<(
  Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'role' | 'gender' | 'blocked' | 'emailConfirmed' | 'mobileConfirmed' | 'notificationPreferences' | 'createdAt' | 'lastHealthPPECheck' | 'healthPPEConfirmed' | 'profileUrl' | 'tags' | 'stripePayoutEnabled' | 'stripeAccountStatus'>
  & { subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>> }
)> };

export type SendCustomMessageQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  messageData?: InputMaybe<Scalars['JSONObject']>;
}>;

export type SendCustomMessageQuery = Pick<Query, 'sendCustomMessage'>;

export type ReviewsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type ReviewsQuery = { reviews?: Maybe<Array<Maybe<(
  Pick<Review, '_id' | 'professionalId' | 'bookingId' | 'comment' | 'feedback' | 'createdAt' | 'flagged' | 'featured' | 'rating' | 'reviewer' | 'hidden'>
  & { user?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName'>>, professional?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName'>>, booking?: Maybe<Pick<Booking, '_id'>> }
)>>> };

export type UpdateReviewMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<ReviewUpdate>;
}>;

export type UpdateReviewMutation = { updateReview?: Maybe<(
  Pick<Review, '_id' | 'professionalId' | 'bookingId' | 'comment' | 'feedback' | 'createdAt' | 'flagged' | 'featured' | 'rating' | 'reviewer' | 'hidden'>
  & { user?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName'>>, professional?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName'>>, booking?: Maybe<Pick<Booking, '_id'>> }
)> };

export type DeleteReviewMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type DeleteReviewMutation = Pick<Mutation, 'deleteReview'>;

export type ReviewQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type ReviewQuery = { review?: Maybe<(
  Pick<Review, '_id' | 'professionalId' | 'bookingId' | 'comment' | 'feedback' | 'createdAt' | 'flagged' | 'featured' | 'rating' | 'reviewer' | 'hidden'>
  & { user?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName'>>, professional?: Maybe<Pick<User, '_id' | 'firstName' | 'lastName'>>, booking?: Maybe<Pick<Booking, '_id'>> }
)> };

export type FavouritesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;

export type FavouritesQuery = { favourites?: Maybe<Array<Maybe<(
  Pick<Favourite, '_id'>
  & { professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'gender'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>> }
  )> }
)>>> };

export type AddFavouriteMutationVariables = Exact<{
  professionalId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
}>;

export type AddFavouriteMutation = { addFavourite?: Maybe<(
  Pick<Favourite, '_id'>
  & { professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'gender'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>> }
  )> }
)> };

export type RemoveFavouriteMutationVariables = Exact<{
  professionalId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
}>;

export type RemoveFavouriteMutation = { removeFavourite?: Maybe<(
  Pick<Favourite, '_id'>
  & { professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'gender'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'escalationGroup' | 'bio' | 'regions' | 'numberOfBookings' | 'featured' | 'updatedAvailabilityAt' | 'information' | 'genderPreference' | 'disabledOptionIds' | 'treatmentIds' | 'treatmentTypes'>> }
  )> }
)> };

export type QuestionsQueryVariables = Exact<{
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type QuestionsQuery = { questions?: Maybe<{ address?: Maybe<Array<Maybe<Pick<UserAddress, '_id' | 'label' | 'firstLine' | 'secondLine' | 'city' | 'postalCode' | 'note' | 'setDefaultAt' | 'userId'>>>> }> };

export type AddOrUpdateAddressMutationVariables = Exact<{
  address?: InputMaybe<UserAddressInput>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type AddOrUpdateAddressMutation = { addOrUpdateAddress?: Maybe<Pick<UserAddress, '_id' | 'label' | 'firstLine' | 'secondLine' | 'city' | 'postalCode' | 'note' | 'setDefaultAt' | 'userId'>> };

export type RemoveAddressMutationVariables = Exact<{
  addressId?: InputMaybe<Scalars['String']>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type RemoveAddressMutation = Pick<Mutation, 'removeAddress'>;

export type GetParkingInformationQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  addressId?: InputMaybe<Scalars['String']>;
}>;

export type GetParkingInformationQuery = { getParkingInformation?: Maybe<Pick<ParkingInformation, '_id' | 'locationDetails' | 'locationType' | 'cost' | 'note' | 'postcode' | 'addressId' | 'proComments'>> };

export type AddorUpdateParkingInformationMutationVariables = Exact<{
  data: ParkingInformationInput;
}>;

export type AddorUpdateParkingInformationMutation = { addorUpdateParkingInformation?: Maybe<Pick<ParkingInformation, '_id' | 'locationDetails' | 'locationType' | 'cost' | 'note' | 'postcode' | 'addressId' | 'proComments'>> };

export type TransactionsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
}>;

export type TransactionsQuery = { transactions?: Maybe<Array<Maybe<Pick<Transaction, '_id' | 'createdAt' | 'userId' | 'adminId' | 'orderId' | 'sourceId' | 'sourceType' | 'transactionType' | 'amount' | 'note' | 'status' | 'orderType' | 'category'>>>> };

export type PagesQueryVariables = Exact<{ [key: string]: never; }>;

export type PagesQuery = { pages?: Maybe<Array<Maybe<Pick<Page, '_id' | 'title' | 'body' | 'type'>>>> };

export type PageQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']>;
}>;

export type PageQuery = { page?: Maybe<Pick<Page, '_id' | 'title' | 'body' | 'type'>> };

export type CreateOrUpdatePageMutationVariables = Exact<{
  type?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
}>;

export type CreateOrUpdatePageMutation = { createOrUpdatePage?: Maybe<Pick<Page, '_id' | 'title' | 'body' | 'type'>> };

export type ProfessionalApplicationsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  search?: InputMaybe<Scalars['String']>;
}>;

export type ProfessionalApplicationsQuery = { professionalApplications?: Maybe<Array<Maybe<(
  Pick<ProfessionalApplication, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'postalCode' | 'gender' | 'city' | 'careerStartDate' | 'website' | 'instagram' | 'categories' | 'old_qualifications' | 'employmentHistory' | 'careerHighlights' | 'verified' | 'status' | 'old_documents' | 'createdAt' | 'verifiedDate' | 'insuranceExpiryDate' | 'note' | 'userId' | 'referral' | 'referralName' | 'interviewDate' | 'bio' | 'bookingsPerWeek' | 'currentSituation' | 'currentSituationOther'>
  & { qualifications?: Maybe<Array<Maybe<(
    Pick<Qualification, 'title' | 'dateObtained'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, documents?: Maybe<Array<Maybe<(
    Pick<ApplicationDocument, 'title' | 'expiryDate' | 'status' | 'dateAdded'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, feedback?: Maybe<Array<Maybe<Pick<ApplicationFeedback, 'comment' | 'createdAt'>>>> }
)>>> };

export type ProfessionalApplicationQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type ProfessionalApplicationQuery = { professionalApplication?: Maybe<(
  Pick<ProfessionalApplication, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'postalCode' | 'gender' | 'city' | 'careerStartDate' | 'website' | 'instagram' | 'categories' | 'old_qualifications' | 'employmentHistory' | 'careerHighlights' | 'verified' | 'status' | 'old_documents' | 'createdAt' | 'verifiedDate' | 'insuranceExpiryDate' | 'note' | 'userId' | 'referral' | 'referralName' | 'interviewDate' | 'bio' | 'bookingsPerWeek' | 'currentSituation' | 'currentSituationOther'>
  & { qualifications?: Maybe<Array<Maybe<(
    Pick<Qualification, 'title' | 'dateObtained'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, documents?: Maybe<Array<Maybe<(
    Pick<ApplicationDocument, 'title' | 'expiryDate' | 'status' | 'dateAdded'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, feedback?: Maybe<Array<Maybe<Pick<ApplicationFeedback, 'comment' | 'createdAt'>>>> }
)> };

export type UpdateProfessionalApplicationMutationVariables = Exact<{
  _id: Scalars['String'];
  data?: InputMaybe<ProfessionalApplicationInput>;
}>;

export type UpdateProfessionalApplicationMutation = { updateProfessionalApplication?: Maybe<(
  Pick<ProfessionalApplication, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'postalCode' | 'gender' | 'city' | 'careerStartDate' | 'website' | 'instagram' | 'categories' | 'old_qualifications' | 'employmentHistory' | 'careerHighlights' | 'verified' | 'status' | 'old_documents' | 'createdAt' | 'verifiedDate' | 'insuranceExpiryDate' | 'note' | 'userId' | 'referral' | 'referralName' | 'interviewDate' | 'bio' | 'bookingsPerWeek' | 'currentSituation' | 'currentSituationOther'>
  & { qualifications?: Maybe<Array<Maybe<(
    Pick<Qualification, 'title' | 'dateObtained'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, documents?: Maybe<Array<Maybe<(
    Pick<ApplicationDocument, 'title' | 'expiryDate' | 'status' | 'dateAdded'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, feedback?: Maybe<Array<Maybe<Pick<ApplicationFeedback, 'comment' | 'createdAt'>>>> }
)> };

export type VerifyProfessionalApplicationMutationVariables = Exact<{
  id: Scalars['String'];
  userId: Scalars['String'];
  data?: InputMaybe<ProfessionalApplicationInput>;
}>;

export type VerifyProfessionalApplicationMutation = { verifyProfessionalApplication?: Maybe<(
  Pick<ProfessionalApplication, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'postalCode' | 'gender' | 'city' | 'careerStartDate' | 'website' | 'instagram' | 'categories' | 'old_qualifications' | 'employmentHistory' | 'careerHighlights' | 'verified' | 'status' | 'old_documents' | 'createdAt' | 'verifiedDate' | 'insuranceExpiryDate' | 'note' | 'userId' | 'referral' | 'referralName' | 'interviewDate' | 'bio' | 'bookingsPerWeek' | 'currentSituation' | 'currentSituationOther'>
  & { qualifications?: Maybe<Array<Maybe<(
    Pick<Qualification, 'title' | 'dateObtained'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, documents?: Maybe<Array<Maybe<(
    Pick<ApplicationDocument, 'title' | 'expiryDate' | 'status' | 'dateAdded'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, feedback?: Maybe<Array<Maybe<Pick<ApplicationFeedback, 'comment' | 'createdAt'>>>> }
)> };

export type TradeTestProfessionalApplicationMutationVariables = Exact<{
  id: Scalars['String'];
  data?: InputMaybe<ProfessionalApplicationInput>;
}>;

export type TradeTestProfessionalApplicationMutation = { tradeTestProfessionalApplication?: Maybe<(
  Pick<ProfessionalApplication, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'postalCode' | 'gender' | 'city' | 'careerStartDate' | 'website' | 'instagram' | 'categories' | 'old_qualifications' | 'employmentHistory' | 'careerHighlights' | 'verified' | 'status' | 'old_documents' | 'createdAt' | 'verifiedDate' | 'insuranceExpiryDate' | 'note' | 'userId' | 'referral' | 'referralName' | 'interviewDate' | 'bio' | 'bookingsPerWeek' | 'currentSituation' | 'currentSituationOther'>
  & { qualifications?: Maybe<Array<Maybe<(
    Pick<Qualification, 'title' | 'dateObtained'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, documents?: Maybe<Array<Maybe<(
    Pick<ApplicationDocument, 'title' | 'expiryDate' | 'status' | 'dateAdded'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, feedback?: Maybe<Array<Maybe<Pick<ApplicationFeedback, 'comment' | 'createdAt'>>>> }
)> };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload'];
  path?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
}>;

export type UploadFileMutation = Pick<Mutation, 'uploadFile'>;

export type DeleteFileMutationVariables = Exact<{
  filename?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
}>;

export type DeleteFileMutation = Pick<Mutation, 'deleteFile'>;

export type LeaveFeedbackMutationVariables = Exact<{
  _id: Scalars['String'];
  feedback: ApplicationFeedbackInput;
}>;

export type LeaveFeedbackMutation = { leaveFeedback?: Maybe<(
  Pick<ProfessionalApplication, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'postalCode' | 'gender' | 'city' | 'careerStartDate' | 'website' | 'instagram' | 'categories' | 'old_qualifications' | 'employmentHistory' | 'careerHighlights' | 'verified' | 'status' | 'old_documents' | 'createdAt' | 'verifiedDate' | 'insuranceExpiryDate' | 'note' | 'userId' | 'referral' | 'referralName' | 'interviewDate' | 'bio' | 'bookingsPerWeek' | 'currentSituation' | 'currentSituationOther'>
  & { qualifications?: Maybe<Array<Maybe<(
    Pick<Qualification, 'title' | 'dateObtained'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, documents?: Maybe<Array<Maybe<(
    Pick<ApplicationDocument, 'title' | 'expiryDate' | 'status' | 'dateAdded'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, feedback?: Maybe<Array<Maybe<Pick<ApplicationFeedback, 'comment' | 'createdAt'>>>> }
)> };

export type CreateGiftCardsBatchMutationVariables = Exact<{
  data?: InputMaybe<GiftCardBatchInput>;
}>;

export type CreateGiftCardsBatchMutation = { createGiftCardsBatch?: Maybe<Array<Maybe<Pick<GiftCard, '_id' | 'code'>>>> };

export type CreateBookingReportMutationVariables = Exact<{
  data?: InputMaybe<BookingReportInput>;
}>;

export type CreateBookingReportMutation = { createBookingReport?: Maybe<Pick<BookingReport, 'reason' | 'reportType' | 'professionalId' | 'bookingId' | 'bookingDate' | 'notes'>> };

export type SettingsQueryVariables = Exact<{ [key: string]: never; }>;

export type SettingsQuery = { settings?: Maybe<Pick<Setting, '_id' | 'platform' | 'settings'>> };

export type InAppMessagesQueryVariables = Exact<{
  filter: InAppMessageFilter;
}>;

export type InAppMessagesQuery = { inAppMessages: Array<Pick<InAppMessage, '_id' | 'name' | 'platform' | 'eventName' | 'match' | 'contentType' | 'updatedAt' | 'published'>> };

export type InAppMessageQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type InAppMessageQuery = { inAppMessage?: Maybe<Pick<InAppMessage, '_id' | 'name' | 'platform' | 'eventName' | 'match' | 'contentType' | 'updatedAt' | 'published' | 'content' | 'createdAt'>> };

export const ChatFieldsFragmentDoc = gql`
    fragment ChatFields on Chat {
  _id
  professionalId
  professional {
    firstName
    lastName
  }
  clientId
  client {
    firstName
    lastName
  }
  lastMessage {
    message
    sentAt
  }
  messageCount {
    professional {
      unreadMessages
      sent
    }
    client {
      unreadMessages
      sent
    }
  }
}
    `
export const AuthTokenFieldsFragmentDoc = gql`
    fragment AuthTokenFields on AuthToken {
  auth
  role
  expires
}
    `
export const InAppMessageFieldsFragmentDoc = gql`
    fragment InAppMessageFields on InAppMessage {
  _id
  name
  platform
  eventName
  match
  contentType
  published
  content
  createdAt
  updatedAt
}
    `
export const ProfessionalFieldsFragmentDoc = gql`
    fragment ProfessionalFields on Professional {
  _id
  firstName
  lastName
  emailAddress
  mobile
  role
  gender
  blocked
  emailConfirmed
  mobileConfirmed
  notificationPreferences
  createdAt
  lastHealthPPECheck
  healthPPEConfirmed
  profileUrl
  tags
  stripePayoutEnabled
  stripeAccountStatus
}
    `
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  _id
  firstName
  lastName
  emailAddress
  mobile
  role
  gender
  blocked
  emailConfirmed
  mobileConfirmed
  notificationPreferences
  createdAt
  lastHealthPPECheck
  healthPPEConfirmed
  profileUrl
  tags
  stripePayoutEnabled
  stripeAccountStatus
  subscriptionDetails {
    status
  }
}
    `
export const ProfessionalProfileFieldsFragmentDoc = gql`
    fragment ProfessionalProfileFields on ProfessionalProfile {
  favouriteCount
  reviewCount
  averageReview
  escalationGroup
  bio
  regions
  numberOfBookings
  featured
  updatedAvailabilityAt
  information
  genderPreference
  disabledOptionIds
  treatmentIds
  treatmentTypes
}
    `
export const PostcodeFieldsFragmentDoc = gql`
    fragment PostcodeFields on Postcode {
  _id
  code
  name
  region
  locality
  active
  subRegion
  featured
  congestion
  hidden
}
    `
export const BookingFieldsFragmentDoc = gql`
    fragment BookingFields on Booking {
  _id
  user {
    _id
    firstName
    lastName
    emailAddress
    tags
  }
  professional {
    _id
    firstName
    lastName
    lastHealthPPECheck
    healthPPEConfirmed
    professionalProfile {
      ...ProfessionalProfileFields
    }
  }
  clientReview {
    _id
    comment
    rating
    feedback
    wouldRebookPro
  }
  professionalReview {
    _id
    comment
    rating
  }
  date
  status
  requestStatus
  clientDetails {
    firstName
    note
    contactNumber
    accountOwner
    gender
  }
  address
  totalPrice
  totalFee
  totalDuration
  title
  items
  createdAt
  publishedDate
  cancelledDate
  type
  promoCodeDiscount
  payoutDrafted
  payoutRequired
  promoCode {
    _id
    promoCode
    redeemAction {
      action
    }
  }
  postcode {
    ...PostcodeFields
  }
  payoutDate
  note
  tags
  region
  requestExpired
  requestedFavouriteIds
  requestedProfessionalIds
  rejectedByIds
  platform
  payoutPercentage
  reviewPrompted
  clientNote
  clientPictures
}
    ${ProfessionalProfileFieldsFragmentDoc}
${PostcodeFieldsFragmentDoc}`
export const AdjustmentFieldsFragmentDoc = gql`
    fragment AdjustmentFields on Adjustment {
  _id
  bookingId
  professionalId
  note
  amount
  adjustmentType
  payoutDrafted
  createdAt
  payoutDate
}
    `
export const TreatmentFieldsFragmentDoc = gql`
    fragment TreatmentFields on Treatment {
  _id
  name
  tags
  type
  isOption
  isTreatment
  isPackage
  duration
  active
  price
  fee
  prices {
    region
    amount
  }
  testPrices {
    region
    amount
  }
  fees {
    region
    amount
  }
  notes
  shortDescription
  info {
    title
    body
  }
  optionGroups {
    name
    multiSelect
    defaultIndex
    optionIds
    options {
      _id
      price
      fee
      name
      duration
      isOption
      isTreatment
      active
    }
  }
  regions
}
    `
export const ProfessionalAnalyticFieldsFragmentDoc = gql`
    fragment ProfessionalAnalyticFields on ProfessionalAnalytic {
  _id
  firstName
  lastName
  earnings {
    currentPeriod
    previousPeriod
  }
  hours {
    currentPeriod
    previousPeriod
  }
  averageReview {
    currentPeriod
    previousPeriod
  }
  reviewCount {
    currentPeriod
    previousPeriod
  }
  numberOfBookings {
    currentPeriod
    previousPeriod
  }
  favourites {
    currentPeriod
    previousPeriod
  }
  repeatCustomer {
    currentPeriod
    previousPeriod
  }
  droppedBookings {
    currentPeriod
    previousPeriod
  }
}
    `
export const CategoryFieldsFragmentDoc = gql`
    fragment CategoryFields on Category {
  _id
  name
  active
  treatmentIds
  regions
  order
  slug
  description
  images {
    image
    text
  }
}
    `
export const PageFieldsFragmentDoc = gql`
    fragment PageFields on Page {
  _id
  title
  body
  type
}
    `
export const GiftCardFieldsFragmentDoc = gql`
    fragment GiftCardFields on GiftCard {
  _id
  type
  recipientEmail
  fromEmail
  recipientName
  fromId
  fromName
  note
  sentTo
  amount
  redeemedById
  code
  blocked
  batched
  recipientAddress
  createdAt
  treatmentId
  treatment {
    name
  }
}
    `
export const CardFieldsFragmentDoc = gql`
    fragment CardFields on Card {
  _id
  setDefaultAt
  userId
  stripePaymentMethod
  expMonth
  expYear
  lastFourDigits
  brand
  blocked
  blockedReason
}
    `
export const FavouriteFieldsFragmentDoc = gql`
    fragment FavouriteFields on Favourite {
  _id
  professional {
    _id
    firstName
    lastName
    emailAddress
    mobile
    gender
    professionalProfile {
      ...ProfessionalProfileFields
    }
  }
}
    ${ProfessionalProfileFieldsFragmentDoc}`
export const TransactionFieldsFragmentDoc = gql`
    fragment TransactionFields on Transaction {
  _id
  createdAt
  userId
  adminId
  orderId
  sourceId
  sourceType
  transactionType
  amount
  note
  status
  orderType
  category
}
    `
export const ReviewFieldsFragmentDoc = gql`
    fragment ReviewFields on Review {
  _id
  professionalId
  bookingId
  user {
    _id
    firstName
    lastName
  }
  professional {
    _id
    firstName
    lastName
  }
  booking {
    _id
  }
  comment
  feedback
  createdAt
  flagged
  featured
  rating
  reviewer
  hidden
}
    `
export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on UserAddress {
  _id
  label
  firstLine
  secondLine
  city
  postalCode
  note
  setDefaultAt
  userId
}
    `
export const ProfessionalApplicationFieldsFragmentDoc = gql`
    fragment ProfessionalApplicationFields on ProfessionalApplication {
  _id
  firstName
  lastName
  emailAddress
  mobile
  postalCode
  gender
  city
  careerStartDate
  website
  instagram
  categories
  qualifications {
    title
    dateObtained
    files {
      url
      status
    }
  }
  old_qualifications
  employmentHistory
  careerHighlights
  verified
  status
  documents {
    title
    expiryDate
    status
    dateAdded
    files {
      url
      status
    }
  }
  old_documents
  createdAt
  verifiedDate
  insuranceExpiryDate
  note
  userId
  referral
  referralName
  interviewDate
  bio
  bookingsPerWeek
  currentSituation
  currentSituationOther
  feedback {
    comment
    createdAt
  }
}
    `
export const PayoutFieldsFragmentDoc = gql`
    fragment PayoutFields on Payout {
  _id
  professionalId
  status
  stripeDueDate
  createdAt
  amount
  transferredAmount
  professional {
    _id
    firstName
    lastName
    stripeAccountStatus
    stripeConnectedAccount
  }
  items {
    bookingId
    adjustmentId
    amount
    date
    note
    type
  }
}
    `
export const FindOrCreateChatDocument = gql`
    mutation findOrCreateChat($professionalId: String, $clientId: String) {
  findOrCreateChat(professionalId: $professionalId, clientId: $clientId) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`
export const LoginWithEmailAndPasswordDocument = gql`
    query loginWithEmailAndPassword($emailAddress: String, $password: String) {
  loginWithEmailAndPassword(emailAddress: $emailAddress, password: $password) {
    authToken {
      ...AuthTokenFields
    }
    user {
      ...UserFields
    }
  }
}
    ${AuthTokenFieldsFragmentDoc}
${UserFieldsFragmentDoc}`
export const VerifyMobileAndSignInDocument = gql`
    mutation verifyMobileAndSignIn($mobile: String, $code: String) {
  verifyMobileAndSignIn(mobile: $mobile, code: $code) {
    authToken {
      ...AuthTokenFields
    }
    user {
      ...UserFields
    }
  }
}
    ${AuthTokenFieldsFragmentDoc}
${UserFieldsFragmentDoc}`
export const SendMobileVerificationDocument = gql`
    query sendMobileVerification($mobile: String, $silent: Boolean) {
  sendMobileVerification(mobile: $mobile, silent: $silent) {
    authToken {
      ...AuthTokenFields
    }
  }
}
    ${AuthTokenFieldsFragmentDoc}`
export const CheckBlockedUserDocument = gql`
    query checkBlockedUser {
  checkBlockedUser
}
    `
export const AppVerDocument = gql`
    query appVer {
  appVer {
    minConsumerAppVer
    minProAppVer
  }
}
    `
export const CreateSuperAdminUserDocument = gql`
    mutation createSuperAdminUser($firstName: String!, $lastName: String!, $emailAddress: String!, $password: String!, $mobile: String!) {
  createSuperAdminUser(
    firstName: $firstName
    lastName: $lastName
    emailAddress: $emailAddress
    password: $password
    mobile: $mobile
  )
}
    `
export const BookingsDocument = gql`
    query bookings($filter: JSONObject, $sort: JSONObject, $pagination: Pagination, $search: String) {
  bookings(filter: $filter, sort: $sort, pagination: $pagination, search: $search) {
    ...BookingFields
    requestedProfessionals {
      _id
      firstName
      lastName
    }
  }
}
    ${BookingFieldsFragmentDoc}`
export const BookingDocument = gql`
    query booking($_id: String) {
  booking(_id: $_id) {
    ...BookingFields
    requestedProfessionals {
      _id
      firstName
      lastName
    }
  }
}
    ${BookingFieldsFragmentDoc}`
export const GetChatAuthTokenDocument = gql`
    query getChatAuthToken($_id: String!, $validUntil: Date!) {
  getChatAuthToken(_id: $_id, validUntil: $validUntil)
}
    `
export const AddOrUpdateBookingDocument = gql`
    mutation addOrUpdateBooking($data: AdminBookingInput) {
  addOrUpdateBooking(data: $data) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`
export const UpdateBookingStatusDocument = gql`
    mutation updateBookingStatus($_id: String, $status: String, $admin: JSONObject) {
  updateBookingStatus(_id: $_id, status: $status, admin: $admin)
}
    `
export const AcceptBookingDocument = gql`
    mutation acceptBooking($_id: String, $ignoreConflictingBookings: Boolean, $admin: JSONObject) {
  acceptBooking(
    _id: $_id
    ignoreConflictingBookings: $ignoreConflictingBookings
    admin: $admin
  )
}
    `
export const PublishBookingDocument = gql`
    mutation publishBooking($data: BookingInput, $sendNotifications: Boolean) {
  publishBooking(data: $data, sendNotifications: $sendNotifications) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`
export const CreateOrUpdateInAppMessageDocument = gql`
    mutation createOrUpdateInAppMessage($data: InAppMessageInput!) {
  createOrUpdateInAppMessage(data: $data) {
    ...InAppMessageFields
  }
}
    ${InAppMessageFieldsFragmentDoc}`
export const NotifyRequestedProfessionalsDocument = gql`
    mutation notifyRequestedProfessionals($_id: String) {
  notifyRequestedProfessionals(_id: $_id)
}
    `
export const CancelBookingDocument = gql`
    mutation cancelBooking($_id: String, $admin: JSONObject) {
  cancelBooking(_id: $_id, admin: $admin)
}
    `
export const AdjustmentsDocument = gql`
    query adjustments($query: JSONObject) {
  adjustments(query: $query) {
    ...AdjustmentFields
  }
}
    ${AdjustmentFieldsFragmentDoc}`
export const CreateAdjustmentDocument = gql`
    mutation createAdjustment($data: AdjustmentInput) {
  createAdjustment(data: $data) {
    ...AdjustmentFields
  }
}
    ${AdjustmentFieldsFragmentDoc}`
export const GetTreatmentsDocument = gql`
    query getTreatments($filter: JSONObject, $sort: JSONObject, $pagination: Pagination, $search: String, $admin: JSONObject) {
  getTreatments(
    filter: $filter
    sort: $sort
    pagination: $pagination
    search: $search
    admin: $admin
  ) {
    _id
    name
    type
    isOption
    isTreatment
    isPackage
    active
    notes
    regions
  }
}
    `
export const GetTreatmentDocument = gql`
    query getTreatment($_id: String!, $getOptions: Boolean, $region: String, $admin: JSONObject) {
  getTreatment(_id: $_id, getOptions: $getOptions, region: $region, admin: $admin) {
    ...TreatmentFields
  }
}
    ${TreatmentFieldsFragmentDoc}`
export const AddOrUpdateTreatmentDocument = gql`
    mutation addOrUpdateTreatment($data: TreatmentInput!) {
  addOrUpdateTreatment(data: $data) {
    _id
    name
  }
}
    `
export const GetProfessionalsDocument = gql`
    query getProfessionals($filter: JSONObject, $sort: JSONObject, $pagination: Pagination, $search: String) {
  getProfessionals(
    filter: $filter
    sort: $sort
    pagination: $pagination
    search: $search
  ) {
    ...ProfessionalFields
    professionalProfile {
      ...ProfessionalProfileFields
    }
  }
}
    ${ProfessionalFieldsFragmentDoc}
${ProfessionalProfileFieldsFragmentDoc}`
export const GetProfessionalsAnalyticsDocument = gql`
    query getProfessionalsAnalytics($filter: JSONObject, $sort: JSONObject, $pagination: Pagination, $search: String) {
  getProfessionalsAnalytics(
    filter: $filter
    sort: $sort
    pagination: $pagination
    search: $search
  ) {
    ...ProfessionalAnalyticFields
  }
}
    ${ProfessionalAnalyticFieldsFragmentDoc}`
export const GetProfessionalAnalyticsDocument = gql`
    query getProfessionalAnalytics($_id: String, $periods: [PeriodsInput]) {
  getProfessionalAnalytics(_id: $_id, periods: $periods) {
    ...ProfessionalAnalyticFields
  }
}
    ${ProfessionalAnalyticFieldsFragmentDoc}`
export const GetProfessionalDocument = gql`
    query getProfessional($_id: String) {
  getProfessional(_id: $_id) {
    ...ProfessionalFields
    acceptedTermsPA
    professionalProfile {
      ...ProfessionalProfileFields
      treatmentIds
      disabledOptionIds
      postcodeIds
      acceptedTermsPA
      defaultTransportMode
    }
  }
}
    ${ProfessionalFieldsFragmentDoc}
${ProfessionalProfileFieldsFragmentDoc}`
export const FindInstantProfessionalsDocument = gql`
    query findInstantProfessionals($matchingParams: InstantMatchingParams, $days: [String], $proProfileFilter: JSONObject) {
  findInstantProfessionals(
    matchingParams: $matchingParams
    days: $days
    proProfileFilter: $proProfileFilter
  ) {
    day
    professionals {
      professional {
        _id
        firstName
        lastName
        tags
        professionalProfile {
          favouriteCount
          reviewCount
          averageReview
          featured
          updatedAvailabilityAt
          numberOfBookings
        }
      }
      day
      availableTimeSlots
      bookedTimesSlots
    }
  }
}
    `
export const GetProfessionalAvailabilityDocument = gql`
    query getProfessionalAvailability($from: String, $to: String, $filter: JSONObject, $admin: JSONObject) {
  getProfessionalAvailability(
    from: $from
    to: $to
    filter: $filter
    admin: $admin
  ) {
    day
    status
    times
    treatmentIds
    postcodeIds
    transportMode
  }
}
    `
export const RemoveProfessionalAvailabilityDocument = gql`
    mutation removeProfessionalAvailability($filter: ProfessionalAvailabilityInput) {
  removeProfessionalAvailability(filter: $filter)
}
    `
export const GetProfessionalAgendasDocument = gql`
    query getProfessionalAgendas($days: [String], $admin: JSONObject) {
  getProfessionalAgendas(days: $days, admin: $admin) {
    day
    events {
      date
      title
      color
      bookingId
      startHour
      durationHours
      outerCode
      type
    }
    availability {
      day
      status
      times
      treatmentIds
      postcodeIds
      transportMode
      updatedAt
      treatments {
        _id
        name
      }
      postcodes {
        code
      }
    }
    history {
      day
      status
      times
      treatmentIds
      postcodeIds
      transportMode
      updatedAt
      treatments {
        _id
        name
      }
      postcodes {
        code
      }
    }
  }
}
    `
export const FindRequestableProfessionalsDocument = gql`
    query findRequestableProfessionals($matchingParams: MatchingParams!, $extendToSubRegion: Boolean!, $admin: JSONObject!) {
  findRequestableProfessionals(
    matchingParams: $matchingParams
    extendToSubRegion: $extendToSubRegion
    admin: $admin
  ) {
    _id
    availabilityStatus {
      treatments
      postcode
      time
      bookingClash
      status
      isFavourite
      subRegionOnly
    }
    professionalProfile {
      userId
      user {
        _id
        firstName
        lastName
        mobile
      }
      favouriteCount
      reviewCount
      averageReview
      numberOfBookings
      updatedAvailabilityAt
    }
  }
}
    `
export const CheckProfessionalAvailabilityDocument = gql`
    query checkProfessionalAvailability($matchingParams: InstantMatchingParams!, $professionalId: String!, $bookingId: String, $date: Date!) {
  checkProfessionalAvailability(
    matchingParams: $matchingParams
    professionalId: $professionalId
    bookingId: $bookingId
    date: $date
  )
}
    `
export const ExtendRequestToProfessionalDocument = gql`
    mutation extendRequestToProfessional($professionalId: String, $bookingId: String, $availabilityStatus: JSONObject) {
  extendRequestToProfessional(
    professionalId: $professionalId
    bookingId: $bookingId
    availabilityStatus: $availabilityStatus
  ) {
    _id
    requestedProfessionalIds
  }
}
    `
export const AddOrUpdateProfessionalUserDocument = gql`
    mutation addOrUpdateProfessionalUser($data: ProfessionalInput) {
  addOrUpdateProfessionalUser(data: $data) {
    ...ProfessionalFields
    professionalProfile {
      ...ProfessionalProfileFields
    }
  }
}
    ${ProfessionalFieldsFragmentDoc}
${ProfessionalProfileFieldsFragmentDoc}`
export const CategoriesDocument = gql`
    query categories($filter: JSONObject) {
  categories(filter: $filter) {
    ...CategoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`
export const CategoryStubsDocument = gql`
    query categoryStubs($filter: JSONObject) {
  categories(filter: $filter) {
    _id
    name
  }
}
    `
export const CategoryDocument = gql`
    query category($_id: String) {
  category(_id: $_id) {
    ...CategoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`
export const SaveCategoryDocument = gql`
    mutation saveCategory($data: CategoryInput!) {
  saveCategory(data: $data) {
    ...CategoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`
export const GetPostcodesDocument = gql`
    query getPostcodes($filter: JSONObject, $sort: JSONObject, $pagination: Pagination, $search: String) {
  getPostcodes(
    filter: $filter
    sort: $sort
    pagination: $pagination
    search: $search
  ) {
    ...PostcodeFields
  }
}
    ${PostcodeFieldsFragmentDoc}`
export const GetPostcodeDocument = gql`
    query getPostcode($_id: String) {
  getPostcode(_id: $_id) {
    ...PostcodeFields
  }
}
    ${PostcodeFieldsFragmentDoc}`
export const CreateOrUpdatePostcodeDocument = gql`
    mutation createOrUpdatePostcode($data: PostcodeInput) {
  createOrUpdatePostcode(postcodeData: $data) {
    ...PostcodeFields
  }
}
    ${PostcodeFieldsFragmentDoc}`
export const CheckPostcodeInServiceAreaDocument = gql`
    query checkPostcodeInServiceArea($postcode: String) {
  checkPostcodeInServiceArea(postcode: $postcode) {
    ...PostcodeFields
  }
}
    ${PostcodeFieldsFragmentDoc}`
export const PromoCodesDocument = gql`
    query promoCodes($filter: JSONObject, $sort: JSONObject, $pagination: Pagination, $search: String) {
  promoCodes(
    filter: $filter
    sort: $sort
    pagination: $pagination
    search: $search
  ) {
    _id
    promoCode
    title
    active
    value
    discountType
    startDate
    expiryDate
    createdAt
    useCount
    tags
  }
}
    `
export const PromoCodeDocument = gql`
    query promoCode($_id: String) {
  promoCode(_id: $_id) {
    _id
    promoCode
    title
    description
    active
    discountType
    value
    campaign
    startDate
    expiryDate
    tags
    featured
    limits {
      availableTo {
        _id
        firstName
        lastName
      }
      unavailableTo {
        _id
        firstName
        lastName
      }
      excludedTreatments {
        _id
        name
      }
      includedTreatments {
        _id
        name
      }
      excludedTreatmentTypes
      includedTreatmentTypes
      bookingsCount
      bookingsCountCondition
      minTreatmentCount
      minBasketValue
      perCustomerCap
      totalAvailable
      days
      hours
      regions
    }
  }
}
    `
export const SavePromoCodeDocument = gql`
    mutation savePromoCode($data: PromoCodeInput) {
  savePromoCode(data: $data) {
    _id
  }
}
    `
export const BatchCreatePromoCodeDocument = gql`
    mutation batchCreatePromoCode($data: PromoCodeInput, $batchData: PromoCodeBatchData) {
  batchCreatePromoCode(data: $data, batchData: $batchData) {
    _id
    promoCode
  }
}
    `
export const CheckPromoCodeDocument = gql`
    query checkPromoCode($promoCode: String!, $booking: PromoBookingInput, $admin: JSONObject) {
  checkPromoCode(promoCode: $promoCode, booking: $booking, admin: $admin) {
    canApply
    promoCodeDiscount
    data {
      _id
      promoCode
      value
      discountType
    }
    reasons {
      reason
      value
    }
  }
}
    `
export const GiftCardsDocument = gql`
    query giftCards($filter: JSONObject, $sort: JSONObject, $pagination: Pagination, $search: String) {
  giftCards(
    filter: $filter
    sort: $sort
    pagination: $pagination
    search: $search
  ) {
    ...GiftCardFields
  }
}
    ${GiftCardFieldsFragmentDoc}`
export const GiftCardDocument = gql`
    query giftCard($_id: String) {
  giftCard(_id: $_id) {
    ...GiftCardFields
  }
}
    ${GiftCardFieldsFragmentDoc}`
export const AddOrUpdateGiftCardDocument = gql`
    mutation addOrUpdateGiftCard($data: GiftCardInput!) {
  addOrUpdateGiftCard(data: $data) {
    _id
  }
}
    `
export const RedeemGiftCardDocument = gql`
    mutation redeemGiftCard($giftCardCode: String, $admin: JSONObject) {
  redeemGiftCard(giftCardCode: $giftCardCode, admin: $admin) {
    amount
  }
}
    `
export const RequestCardSetupIntentDocument = gql`
    query requestCardSetupIntent {
  requestCardSetupIntent
}
    `
export const CardsDocument = gql`
    query cards($admin: JSONObject) {
  cards(admin: $admin) {
    ...CardFields
  }
}
    ${CardFieldsFragmentDoc}`
export const AddCardDocument = gql`
    mutation addCard($token: CardToken, $admin: JSONObject) {
  addCard(token: $token, admin: $admin) {
    ...CardFields
  }
}
    ${CardFieldsFragmentDoc}`
export const RemoveCardDocument = gql`
    mutation removeCard($_id: String, $admin: JSONObject) {
  removeCard(_id: $_id, admin: $admin) {
    _id
  }
}
    `
export const UpdateDefaultCardDocument = gql`
    mutation updateDefaultCard($_id: String, $setDefaultAt: String, $admin: JSONObject) {
  updateDefaultCard(_id: $_id, setDefaultAt: $setDefaultAt, admin: $admin) {
    _id
  }
}
    `
export const UpdateCardBlockedDocument = gql`
    mutation updateCardBlocked($_id: String, $userId: String, $blocked: Boolean) {
  updateCardBlocked(_id: $_id, userId: $userId, blocked: $blocked) {
    ...CardFields
  }
}
    ${CardFieldsFragmentDoc}`
export const CreateTransactionDocument = gql`
    mutation createTransaction($data: TransactionInput) {
  createTransaction(data: $data) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`
export const BalanceDocument = gql`
    query balance($order: OrderDetails, $admin: JSONObject) {
  balance(order: $order, admin: $admin)
}
    `
export const CompletePaymentDocument = gql`
    mutation completePayment($order: Order!, $admin: JSONObject) {
  completePayment(order: $order, admin: $admin) {
    isPaid
  }
}
    `
export const PrepareForPaymentDocument = gql`
    query prepareForPayment($orderInfo: OrderInfo!) {
  prepareForPayment(orderInfo: $orderInfo) {
    clientSecret
    paymentIntentId
  }
}
    `
export const RequestRefundDocument = gql`
    mutation requestRefund($refund: Refund!) {
  requestRefund(refund: $refund)
}
    `
export const PayoutsDocument = gql`
    query payouts($filter: JSONObject, $pagination: Pagination, $admin: JSONObject) {
  payouts(filter: $filter, pagination: $pagination, admin: $admin) {
    ...PayoutFields
  }
}
    ${PayoutFieldsFragmentDoc}`
export const ProfessionalPayoutsDocument = gql`
    query professionalPayouts($admin: AdminPayoutsInput!) {
  professionalPayouts(admin: $admin) {
    ...PayoutFields
  }
}
    ${PayoutFieldsFragmentDoc}`
export const DraftPayoutsDocument = gql`
    mutation draftPayouts($buffer: Int) {
  draftPayouts(buffer: $buffer) {
    ...PayoutFields
  }
}
    ${PayoutFieldsFragmentDoc}`
export const TransferDraftedPayoutsDocument = gql`
    mutation transferDraftedPayouts {
  transferDraftedPayouts {
    payouts {
      ...PayoutFields
    }
    errors
  }
}
    ${PayoutFieldsFragmentDoc}`
export const UsersDocument = gql`
    query users($filter: JSONObject, $sort: JSONObject, $pagination: Pagination, $search: String) {
  users(filter: $filter, sort: $sort, pagination: $pagination, search: $search) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`
export const UserDocument = gql`
    query user($admin: JSONObject) {
  user(admin: $admin) {
    ...UserFields
    acceptedTermsCA
  }
}
    ${UserFieldsFragmentDoc}`
export const SaveUserDocument = gql`
    mutation saveUser($data: UserInput) {
  saveUser(data: $data) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`
export const SendCustomMessageDocument = gql`
    query sendCustomMessage($userId: String, $messageData: JSONObject) {
  sendCustomMessage(userId: $userId, messageData: $messageData)
}
    `
export const ReviewsDocument = gql`
    query reviews($filter: JSONObject, $sort: JSONObject, $pagination: Pagination, $search: String) {
  reviews(filter: $filter, sort: $sort, pagination: $pagination, search: $search) {
    ...ReviewFields
  }
}
    ${ReviewFieldsFragmentDoc}`
export const UpdateReviewDocument = gql`
    mutation updateReview($_id: String, $data: ReviewUpdate) {
  updateReview(_id: $_id, data: $data) {
    ...ReviewFields
  }
}
    ${ReviewFieldsFragmentDoc}`
export const DeleteReviewDocument = gql`
    mutation deleteReview($_id: String) {
  deleteReview(_id: $_id)
}
    `
export const ReviewDocument = gql`
    query review($_id: String) {
  review(_id: $_id) {
    ...ReviewFields
  }
}
    ${ReviewFieldsFragmentDoc}`
export const FavouritesDocument = gql`
    query favourites($userId: String) {
  favourites(userId: $userId) {
    ...FavouriteFields
  }
}
    ${FavouriteFieldsFragmentDoc}`
export const AddFavouriteDocument = gql`
    mutation addFavourite($professionalId: String, $userId: String) {
  addFavourite(professionalId: $professionalId, userId: $userId) {
    ...FavouriteFields
  }
}
    ${FavouriteFieldsFragmentDoc}`
export const RemoveFavouriteDocument = gql`
    mutation removeFavourite($professionalId: String, $userId: String) {
  removeFavourite(professionalId: $professionalId, userId: $userId) {
    ...FavouriteFields
  }
}
    ${FavouriteFieldsFragmentDoc}`
export const QuestionsDocument = gql`
    query questions($filter: [String], $admin: JSONObject) {
  questions(filter: $filter, admin: $admin) {
    address {
      ...AddressFields
    }
  }
}
    ${AddressFieldsFragmentDoc}`
export const AddOrUpdateAddressDocument = gql`
    mutation addOrUpdateAddress($address: UserAddressInput, $admin: JSONObject) {
  addOrUpdateAddress(address: $address, admin: $admin) {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`
export const RemoveAddressDocument = gql`
    mutation removeAddress($addressId: String, $admin: JSONObject) {
  removeAddress(addressId: $addressId, admin: $admin)
}
    `
export const GetParkingInformationDocument = gql`
    query getParkingInformation($_id: String, $addressId: String) {
  getParkingInformation(_id: $_id, addressId: $addressId) {
    _id
    locationDetails
    locationType
    cost
    note
    postcode
    addressId
    proComments
  }
}
    `
export const AddorUpdateParkingInformationDocument = gql`
    mutation addorUpdateParkingInformation($data: ParkingInformationInput!) {
  addorUpdateParkingInformation(data: $data) {
    _id
    locationDetails
    locationType
    cost
    note
    postcode
    addressId
    proComments
  }
}
    `
export const TransactionsDocument = gql`
    query transactions($filter: JSONObject, $pagination: Pagination) {
  transactions(filter: $filter, pagination: $pagination) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`
export const PagesDocument = gql`
    query pages {
  pages {
    ...PageFields
  }
}
    ${PageFieldsFragmentDoc}`
export const PageDocument = gql`
    query page($type: String) {
  page(type: $type) {
    ...PageFields
  }
}
    ${PageFieldsFragmentDoc}`
export const CreateOrUpdatePageDocument = gql`
    mutation createOrUpdatePage($type: String, $title: String, $body: String) {
  createOrUpdatePage(type: $type, title: $title, body: $body) {
    ...PageFields
  }
}
    ${PageFieldsFragmentDoc}`
export const ProfessionalApplicationsDocument = gql`
    query professionalApplications($filter: JSONObject, $pagination: Pagination, $sort: JSONObject, $search: String) {
  professionalApplications(
    filter: $filter
    pagination: $pagination
    sort: $sort
    search: $search
  ) {
    ...ProfessionalApplicationFields
  }
}
    ${ProfessionalApplicationFieldsFragmentDoc}`
export const ProfessionalApplicationDocument = gql`
    query professionalApplication($_id: String) {
  professionalApplication(_id: $_id) {
    ...ProfessionalApplicationFields
  }
}
    ${ProfessionalApplicationFieldsFragmentDoc}`
export const UpdateProfessionalApplicationDocument = gql`
    mutation updateProfessionalApplication($_id: String!, $data: ProfessionalApplicationInput) {
  updateProfessionalApplication(_id: $_id, data: $data) {
    ...ProfessionalApplicationFields
  }
}
    ${ProfessionalApplicationFieldsFragmentDoc}`
export const VerifyProfessionalApplicationDocument = gql`
    mutation verifyProfessionalApplication($id: String!, $userId: String!, $data: ProfessionalApplicationInput) {
  verifyProfessionalApplication(id: $id, userId: $userId, data: $data) {
    ...ProfessionalApplicationFields
  }
}
    ${ProfessionalApplicationFieldsFragmentDoc}`
export const TradeTestProfessionalApplicationDocument = gql`
    mutation tradeTestProfessionalApplication($id: String!, $data: ProfessionalApplicationInput) {
  tradeTestProfessionalApplication(id: $id, data: $data) {
    ...ProfessionalApplicationFields
  }
}
    ${ProfessionalApplicationFieldsFragmentDoc}`
export const UploadFileDocument = gql`
    mutation uploadFile($file: Upload!, $path: String, $filename: String, $type: String) {
  uploadFile(file: $file, path: $path, filename: $filename, type: $type)
}
    `
export const DeleteFileDocument = gql`
    mutation deleteFile($filename: String, $type: String) {
  deleteFile(filename: $filename, type: $type)
}
    `
export const LeaveFeedbackDocument = gql`
    mutation leaveFeedback($_id: String!, $feedback: ApplicationFeedbackInput!) {
  leaveFeedback(_id: $_id, feedback: $feedback) {
    ...ProfessionalApplicationFields
  }
}
    ${ProfessionalApplicationFieldsFragmentDoc}`
export const CreateGiftCardsBatchDocument = gql`
    mutation createGiftCardsBatch($data: GiftCardBatchInput) {
  createGiftCardsBatch(data: $data) {
    _id
    code
  }
}
    `
export const CreateBookingReportDocument = gql`
    mutation createBookingReport($data: BookingReportInput) {
  createBookingReport(data: $data) {
    reason
    reportType
    professionalId
    bookingId
    bookingDate
    notes
  }
}
    `
export const SettingsDocument = gql`
    query settings {
  settings {
    _id
    platform
    settings
  }
}
    `
export const InAppMessagesDocument = gql`
    query inAppMessages($filter: InAppMessageFilter!) {
  inAppMessages(filter: $filter) {
    _id
    name
    platform
    eventName
    match
    contentType
    updatedAt
    published
  }
}
    `
export const InAppMessageDocument = gql`
    query inAppMessage($_id: String!) {
  inAppMessage(_id: $_id) {
    _id
    name
    platform
    eventName
    match
    contentType
    updatedAt
    published
    content
    createdAt
  }
}
    `
export type Requester<C= {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R>
export function getSdk<C>(requester: Requester<C>) {
  return {
    findOrCreateChat(variables?: FindOrCreateChatMutationVariables, options?: C): Promise<FindOrCreateChatMutation> {
      return requester<FindOrCreateChatMutation, FindOrCreateChatMutationVariables>(FindOrCreateChatDocument, variables, options)
    },
    loginWithEmailAndPassword(variables?: LoginWithEmailAndPasswordQueryVariables, options?: C): Promise<LoginWithEmailAndPasswordQuery> {
      return requester<LoginWithEmailAndPasswordQuery, LoginWithEmailAndPasswordQueryVariables>(LoginWithEmailAndPasswordDocument, variables, options)
    },
    verifyMobileAndSignIn(variables?: VerifyMobileAndSignInMutationVariables, options?: C): Promise<VerifyMobileAndSignInMutation> {
      return requester<VerifyMobileAndSignInMutation, VerifyMobileAndSignInMutationVariables>(VerifyMobileAndSignInDocument, variables, options)
    },
    sendMobileVerification(variables?: SendMobileVerificationQueryVariables, options?: C): Promise<SendMobileVerificationQuery> {
      return requester<SendMobileVerificationQuery, SendMobileVerificationQueryVariables>(SendMobileVerificationDocument, variables, options)
    },
    checkBlockedUser(variables?: CheckBlockedUserQueryVariables, options?: C): Promise<CheckBlockedUserQuery> {
      return requester<CheckBlockedUserQuery, CheckBlockedUserQueryVariables>(CheckBlockedUserDocument, variables, options)
    },
    appVer(variables?: AppVerQueryVariables, options?: C): Promise<AppVerQuery> {
      return requester<AppVerQuery, AppVerQueryVariables>(AppVerDocument, variables, options)
    },
    createSuperAdminUser(variables: CreateSuperAdminUserMutationVariables, options?: C): Promise<CreateSuperAdminUserMutation> {
      return requester<CreateSuperAdminUserMutation, CreateSuperAdminUserMutationVariables>(CreateSuperAdminUserDocument, variables, options)
    },
    bookings(variables?: BookingsQueryVariables, options?: C): Promise<BookingsQuery> {
      return requester<BookingsQuery, BookingsQueryVariables>(BookingsDocument, variables, options)
    },
    booking(variables?: BookingQueryVariables, options?: C): Promise<BookingQuery> {
      return requester<BookingQuery, BookingQueryVariables>(BookingDocument, variables, options)
    },
    getChatAuthToken(variables: GetChatAuthTokenQueryVariables, options?: C): Promise<GetChatAuthTokenQuery> {
      return requester<GetChatAuthTokenQuery, GetChatAuthTokenQueryVariables>(GetChatAuthTokenDocument, variables, options)
    },
    addOrUpdateBooking(variables?: AddOrUpdateBookingMutationVariables, options?: C): Promise<AddOrUpdateBookingMutation> {
      return requester<AddOrUpdateBookingMutation, AddOrUpdateBookingMutationVariables>(AddOrUpdateBookingDocument, variables, options)
    },
    updateBookingStatus(variables?: UpdateBookingStatusMutationVariables, options?: C): Promise<UpdateBookingStatusMutation> {
      return requester<UpdateBookingStatusMutation, UpdateBookingStatusMutationVariables>(UpdateBookingStatusDocument, variables, options)
    },
    acceptBooking(variables?: AcceptBookingMutationVariables, options?: C): Promise<AcceptBookingMutation> {
      return requester<AcceptBookingMutation, AcceptBookingMutationVariables>(AcceptBookingDocument, variables, options)
    },
    publishBooking(variables?: PublishBookingMutationVariables, options?: C): Promise<PublishBookingMutation> {
      return requester<PublishBookingMutation, PublishBookingMutationVariables>(PublishBookingDocument, variables, options)
    },
    createOrUpdateInAppMessage(variables: CreateOrUpdateInAppMessageMutationVariables, options?: C): Promise<CreateOrUpdateInAppMessageMutation> {
      return requester<CreateOrUpdateInAppMessageMutation, CreateOrUpdateInAppMessageMutationVariables>(CreateOrUpdateInAppMessageDocument, variables, options)
    },
    notifyRequestedProfessionals(variables?: NotifyRequestedProfessionalsMutationVariables, options?: C): Promise<NotifyRequestedProfessionalsMutation> {
      return requester<NotifyRequestedProfessionalsMutation, NotifyRequestedProfessionalsMutationVariables>(NotifyRequestedProfessionalsDocument, variables, options)
    },
    cancelBooking(variables?: CancelBookingMutationVariables, options?: C): Promise<CancelBookingMutation> {
      return requester<CancelBookingMutation, CancelBookingMutationVariables>(CancelBookingDocument, variables, options)
    },
    adjustments(variables?: AdjustmentsQueryVariables, options?: C): Promise<AdjustmentsQuery> {
      return requester<AdjustmentsQuery, AdjustmentsQueryVariables>(AdjustmentsDocument, variables, options)
    },
    createAdjustment(variables?: CreateAdjustmentMutationVariables, options?: C): Promise<CreateAdjustmentMutation> {
      return requester<CreateAdjustmentMutation, CreateAdjustmentMutationVariables>(CreateAdjustmentDocument, variables, options)
    },
    getTreatments(variables?: GetTreatmentsQueryVariables, options?: C): Promise<GetTreatmentsQuery> {
      return requester<GetTreatmentsQuery, GetTreatmentsQueryVariables>(GetTreatmentsDocument, variables, options)
    },
    getTreatment(variables: GetTreatmentQueryVariables, options?: C): Promise<GetTreatmentQuery> {
      return requester<GetTreatmentQuery, GetTreatmentQueryVariables>(GetTreatmentDocument, variables, options)
    },
    addOrUpdateTreatment(variables: AddOrUpdateTreatmentMutationVariables, options?: C): Promise<AddOrUpdateTreatmentMutation> {
      return requester<AddOrUpdateTreatmentMutation, AddOrUpdateTreatmentMutationVariables>(AddOrUpdateTreatmentDocument, variables, options)
    },
    getProfessionals(variables?: GetProfessionalsQueryVariables, options?: C): Promise<GetProfessionalsQuery> {
      return requester<GetProfessionalsQuery, GetProfessionalsQueryVariables>(GetProfessionalsDocument, variables, options)
    },
    getProfessionalsAnalytics(variables?: GetProfessionalsAnalyticsQueryVariables, options?: C): Promise<GetProfessionalsAnalyticsQuery> {
      return requester<GetProfessionalsAnalyticsQuery, GetProfessionalsAnalyticsQueryVariables>(GetProfessionalsAnalyticsDocument, variables, options)
    },
    getProfessionalAnalytics(variables?: GetProfessionalAnalyticsQueryVariables, options?: C): Promise<GetProfessionalAnalyticsQuery> {
      return requester<GetProfessionalAnalyticsQuery, GetProfessionalAnalyticsQueryVariables>(GetProfessionalAnalyticsDocument, variables, options)
    },
    getProfessional(variables?: GetProfessionalQueryVariables, options?: C): Promise<GetProfessionalQuery> {
      return requester<GetProfessionalQuery, GetProfessionalQueryVariables>(GetProfessionalDocument, variables, options)
    },
    findInstantProfessionals(variables?: FindInstantProfessionalsQueryVariables, options?: C): Promise<FindInstantProfessionalsQuery> {
      return requester<FindInstantProfessionalsQuery, FindInstantProfessionalsQueryVariables>(FindInstantProfessionalsDocument, variables, options)
    },
    getProfessionalAvailability(variables?: GetProfessionalAvailabilityQueryVariables, options?: C): Promise<GetProfessionalAvailabilityQuery> {
      return requester<GetProfessionalAvailabilityQuery, GetProfessionalAvailabilityQueryVariables>(GetProfessionalAvailabilityDocument, variables, options)
    },
    removeProfessionalAvailability(variables?: RemoveProfessionalAvailabilityMutationVariables, options?: C): Promise<RemoveProfessionalAvailabilityMutation> {
      return requester<RemoveProfessionalAvailabilityMutation, RemoveProfessionalAvailabilityMutationVariables>(RemoveProfessionalAvailabilityDocument, variables, options)
    },
    getProfessionalAgendas(variables?: GetProfessionalAgendasQueryVariables, options?: C): Promise<GetProfessionalAgendasQuery> {
      return requester<GetProfessionalAgendasQuery, GetProfessionalAgendasQueryVariables>(GetProfessionalAgendasDocument, variables, options)
    },
    findRequestableProfessionals(variables: FindRequestableProfessionalsQueryVariables, options?: C): Promise<FindRequestableProfessionalsQuery> {
      return requester<FindRequestableProfessionalsQuery, FindRequestableProfessionalsQueryVariables>(FindRequestableProfessionalsDocument, variables, options)
    },
    checkProfessionalAvailability(variables: CheckProfessionalAvailabilityQueryVariables, options?: C): Promise<CheckProfessionalAvailabilityQuery> {
      return requester<CheckProfessionalAvailabilityQuery, CheckProfessionalAvailabilityQueryVariables>(CheckProfessionalAvailabilityDocument, variables, options)
    },
    extendRequestToProfessional(variables?: ExtendRequestToProfessionalMutationVariables, options?: C): Promise<ExtendRequestToProfessionalMutation> {
      return requester<ExtendRequestToProfessionalMutation, ExtendRequestToProfessionalMutationVariables>(ExtendRequestToProfessionalDocument, variables, options)
    },
    addOrUpdateProfessionalUser(variables?: AddOrUpdateProfessionalUserMutationVariables, options?: C): Promise<AddOrUpdateProfessionalUserMutation> {
      return requester<AddOrUpdateProfessionalUserMutation, AddOrUpdateProfessionalUserMutationVariables>(AddOrUpdateProfessionalUserDocument, variables, options)
    },
    categories(variables?: CategoriesQueryVariables, options?: C): Promise<CategoriesQuery> {
      return requester<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, variables, options)
    },
    categoryStubs(variables?: CategoryStubsQueryVariables, options?: C): Promise<CategoryStubsQuery> {
      return requester<CategoryStubsQuery, CategoryStubsQueryVariables>(CategoryStubsDocument, variables, options)
    },
    category(variables?: CategoryQueryVariables, options?: C): Promise<CategoryQuery> {
      return requester<CategoryQuery, CategoryQueryVariables>(CategoryDocument, variables, options)
    },
    saveCategory(variables: SaveCategoryMutationVariables, options?: C): Promise<SaveCategoryMutation> {
      return requester<SaveCategoryMutation, SaveCategoryMutationVariables>(SaveCategoryDocument, variables, options)
    },
    getPostcodes(variables?: GetPostcodesQueryVariables, options?: C): Promise<GetPostcodesQuery> {
      return requester<GetPostcodesQuery, GetPostcodesQueryVariables>(GetPostcodesDocument, variables, options)
    },
    getPostcode(variables?: GetPostcodeQueryVariables, options?: C): Promise<GetPostcodeQuery> {
      return requester<GetPostcodeQuery, GetPostcodeQueryVariables>(GetPostcodeDocument, variables, options)
    },
    createOrUpdatePostcode(variables?: CreateOrUpdatePostcodeMutationVariables, options?: C): Promise<CreateOrUpdatePostcodeMutation> {
      return requester<CreateOrUpdatePostcodeMutation, CreateOrUpdatePostcodeMutationVariables>(CreateOrUpdatePostcodeDocument, variables, options)
    },
    checkPostcodeInServiceArea(variables?: CheckPostcodeInServiceAreaQueryVariables, options?: C): Promise<CheckPostcodeInServiceAreaQuery> {
      return requester<CheckPostcodeInServiceAreaQuery, CheckPostcodeInServiceAreaQueryVariables>(CheckPostcodeInServiceAreaDocument, variables, options)
    },
    promoCodes(variables?: PromoCodesQueryVariables, options?: C): Promise<PromoCodesQuery> {
      return requester<PromoCodesQuery, PromoCodesQueryVariables>(PromoCodesDocument, variables, options)
    },
    promoCode(variables?: PromoCodeQueryVariables, options?: C): Promise<PromoCodeQuery> {
      return requester<PromoCodeQuery, PromoCodeQueryVariables>(PromoCodeDocument, variables, options)
    },
    savePromoCode(variables?: SavePromoCodeMutationVariables, options?: C): Promise<SavePromoCodeMutation> {
      return requester<SavePromoCodeMutation, SavePromoCodeMutationVariables>(SavePromoCodeDocument, variables, options)
    },
    batchCreatePromoCode(variables?: BatchCreatePromoCodeMutationVariables, options?: C): Promise<BatchCreatePromoCodeMutation> {
      return requester<BatchCreatePromoCodeMutation, BatchCreatePromoCodeMutationVariables>(BatchCreatePromoCodeDocument, variables, options)
    },
    checkPromoCode(variables: CheckPromoCodeQueryVariables, options?: C): Promise<CheckPromoCodeQuery> {
      return requester<CheckPromoCodeQuery, CheckPromoCodeQueryVariables>(CheckPromoCodeDocument, variables, options)
    },
    giftCards(variables?: GiftCardsQueryVariables, options?: C): Promise<GiftCardsQuery> {
      return requester<GiftCardsQuery, GiftCardsQueryVariables>(GiftCardsDocument, variables, options)
    },
    giftCard(variables?: GiftCardQueryVariables, options?: C): Promise<GiftCardQuery> {
      return requester<GiftCardQuery, GiftCardQueryVariables>(GiftCardDocument, variables, options)
    },
    addOrUpdateGiftCard(variables: AddOrUpdateGiftCardMutationVariables, options?: C): Promise<AddOrUpdateGiftCardMutation> {
      return requester<AddOrUpdateGiftCardMutation, AddOrUpdateGiftCardMutationVariables>(AddOrUpdateGiftCardDocument, variables, options)
    },
    redeemGiftCard(variables?: RedeemGiftCardMutationVariables, options?: C): Promise<RedeemGiftCardMutation> {
      return requester<RedeemGiftCardMutation, RedeemGiftCardMutationVariables>(RedeemGiftCardDocument, variables, options)
    },
    requestCardSetupIntent(variables?: RequestCardSetupIntentQueryVariables, options?: C): Promise<RequestCardSetupIntentQuery> {
      return requester<RequestCardSetupIntentQuery, RequestCardSetupIntentQueryVariables>(RequestCardSetupIntentDocument, variables, options)
    },
    cards(variables?: CardsQueryVariables, options?: C): Promise<CardsQuery> {
      return requester<CardsQuery, CardsQueryVariables>(CardsDocument, variables, options)
    },
    addCard(variables?: AddCardMutationVariables, options?: C): Promise<AddCardMutation> {
      return requester<AddCardMutation, AddCardMutationVariables>(AddCardDocument, variables, options)
    },
    removeCard(variables?: RemoveCardMutationVariables, options?: C): Promise<RemoveCardMutation> {
      return requester<RemoveCardMutation, RemoveCardMutationVariables>(RemoveCardDocument, variables, options)
    },
    updateDefaultCard(variables?: UpdateDefaultCardMutationVariables, options?: C): Promise<UpdateDefaultCardMutation> {
      return requester<UpdateDefaultCardMutation, UpdateDefaultCardMutationVariables>(UpdateDefaultCardDocument, variables, options)
    },
    updateCardBlocked(variables?: UpdateCardBlockedMutationVariables, options?: C): Promise<UpdateCardBlockedMutation> {
      return requester<UpdateCardBlockedMutation, UpdateCardBlockedMutationVariables>(UpdateCardBlockedDocument, variables, options)
    },
    createTransaction(variables?: CreateTransactionMutationVariables, options?: C): Promise<CreateTransactionMutation> {
      return requester<CreateTransactionMutation, CreateTransactionMutationVariables>(CreateTransactionDocument, variables, options)
    },
    balance(variables?: BalanceQueryVariables, options?: C): Promise<BalanceQuery> {
      return requester<BalanceQuery, BalanceQueryVariables>(BalanceDocument, variables, options)
    },
    completePayment(variables: CompletePaymentMutationVariables, options?: C): Promise<CompletePaymentMutation> {
      return requester<CompletePaymentMutation, CompletePaymentMutationVariables>(CompletePaymentDocument, variables, options)
    },
    prepareForPayment(variables: PrepareForPaymentQueryVariables, options?: C): Promise<PrepareForPaymentQuery> {
      return requester<PrepareForPaymentQuery, PrepareForPaymentQueryVariables>(PrepareForPaymentDocument, variables, options)
    },
    requestRefund(variables: RequestRefundMutationVariables, options?: C): Promise<RequestRefundMutation> {
      return requester<RequestRefundMutation, RequestRefundMutationVariables>(RequestRefundDocument, variables, options)
    },
    payouts(variables?: PayoutsQueryVariables, options?: C): Promise<PayoutsQuery> {
      return requester<PayoutsQuery, PayoutsQueryVariables>(PayoutsDocument, variables, options)
    },
    professionalPayouts(variables: ProfessionalPayoutsQueryVariables, options?: C): Promise<ProfessionalPayoutsQuery> {
      return requester<ProfessionalPayoutsQuery, ProfessionalPayoutsQueryVariables>(ProfessionalPayoutsDocument, variables, options)
    },
    draftPayouts(variables?: DraftPayoutsMutationVariables, options?: C): Promise<DraftPayoutsMutation> {
      return requester<DraftPayoutsMutation, DraftPayoutsMutationVariables>(DraftPayoutsDocument, variables, options)
    },
    transferDraftedPayouts(variables?: TransferDraftedPayoutsMutationVariables, options?: C): Promise<TransferDraftedPayoutsMutation> {
      return requester<TransferDraftedPayoutsMutation, TransferDraftedPayoutsMutationVariables>(TransferDraftedPayoutsDocument, variables, options)
    },
    users(variables?: UsersQueryVariables, options?: C): Promise<UsersQuery> {
      return requester<UsersQuery, UsersQueryVariables>(UsersDocument, variables, options)
    },
    user(variables?: UserQueryVariables, options?: C): Promise<UserQuery> {
      return requester<UserQuery, UserQueryVariables>(UserDocument, variables, options)
    },
    saveUser(variables?: SaveUserMutationVariables, options?: C): Promise<SaveUserMutation> {
      return requester<SaveUserMutation, SaveUserMutationVariables>(SaveUserDocument, variables, options)
    },
    sendCustomMessage(variables?: SendCustomMessageQueryVariables, options?: C): Promise<SendCustomMessageQuery> {
      return requester<SendCustomMessageQuery, SendCustomMessageQueryVariables>(SendCustomMessageDocument, variables, options)
    },
    reviews(variables?: ReviewsQueryVariables, options?: C): Promise<ReviewsQuery> {
      return requester<ReviewsQuery, ReviewsQueryVariables>(ReviewsDocument, variables, options)
    },
    updateReview(variables?: UpdateReviewMutationVariables, options?: C): Promise<UpdateReviewMutation> {
      return requester<UpdateReviewMutation, UpdateReviewMutationVariables>(UpdateReviewDocument, variables, options)
    },
    deleteReview(variables?: DeleteReviewMutationVariables, options?: C): Promise<DeleteReviewMutation> {
      return requester<DeleteReviewMutation, DeleteReviewMutationVariables>(DeleteReviewDocument, variables, options)
    },
    review(variables?: ReviewQueryVariables, options?: C): Promise<ReviewQuery> {
      return requester<ReviewQuery, ReviewQueryVariables>(ReviewDocument, variables, options)
    },
    favourites(variables?: FavouritesQueryVariables, options?: C): Promise<FavouritesQuery> {
      return requester<FavouritesQuery, FavouritesQueryVariables>(FavouritesDocument, variables, options)
    },
    addFavourite(variables?: AddFavouriteMutationVariables, options?: C): Promise<AddFavouriteMutation> {
      return requester<AddFavouriteMutation, AddFavouriteMutationVariables>(AddFavouriteDocument, variables, options)
    },
    removeFavourite(variables?: RemoveFavouriteMutationVariables, options?: C): Promise<RemoveFavouriteMutation> {
      return requester<RemoveFavouriteMutation, RemoveFavouriteMutationVariables>(RemoveFavouriteDocument, variables, options)
    },
    questions(variables?: QuestionsQueryVariables, options?: C): Promise<QuestionsQuery> {
      return requester<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, variables, options)
    },
    addOrUpdateAddress(variables?: AddOrUpdateAddressMutationVariables, options?: C): Promise<AddOrUpdateAddressMutation> {
      return requester<AddOrUpdateAddressMutation, AddOrUpdateAddressMutationVariables>(AddOrUpdateAddressDocument, variables, options)
    },
    removeAddress(variables?: RemoveAddressMutationVariables, options?: C): Promise<RemoveAddressMutation> {
      return requester<RemoveAddressMutation, RemoveAddressMutationVariables>(RemoveAddressDocument, variables, options)
    },
    getParkingInformation(variables?: GetParkingInformationQueryVariables, options?: C): Promise<GetParkingInformationQuery> {
      return requester<GetParkingInformationQuery, GetParkingInformationQueryVariables>(GetParkingInformationDocument, variables, options)
    },
    addorUpdateParkingInformation(variables: AddorUpdateParkingInformationMutationVariables, options?: C): Promise<AddorUpdateParkingInformationMutation> {
      return requester<AddorUpdateParkingInformationMutation, AddorUpdateParkingInformationMutationVariables>(AddorUpdateParkingInformationDocument, variables, options)
    },
    transactions(variables?: TransactionsQueryVariables, options?: C): Promise<TransactionsQuery> {
      return requester<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, variables, options)
    },
    pages(variables?: PagesQueryVariables, options?: C): Promise<PagesQuery> {
      return requester<PagesQuery, PagesQueryVariables>(PagesDocument, variables, options)
    },
    page(variables?: PageQueryVariables, options?: C): Promise<PageQuery> {
      return requester<PageQuery, PageQueryVariables>(PageDocument, variables, options)
    },
    createOrUpdatePage(variables?: CreateOrUpdatePageMutationVariables, options?: C): Promise<CreateOrUpdatePageMutation> {
      return requester<CreateOrUpdatePageMutation, CreateOrUpdatePageMutationVariables>(CreateOrUpdatePageDocument, variables, options)
    },
    professionalApplications(variables?: ProfessionalApplicationsQueryVariables, options?: C): Promise<ProfessionalApplicationsQuery> {
      return requester<ProfessionalApplicationsQuery, ProfessionalApplicationsQueryVariables>(ProfessionalApplicationsDocument, variables, options)
    },
    professionalApplication(variables?: ProfessionalApplicationQueryVariables, options?: C): Promise<ProfessionalApplicationQuery> {
      return requester<ProfessionalApplicationQuery, ProfessionalApplicationQueryVariables>(ProfessionalApplicationDocument, variables, options)
    },
    updateProfessionalApplication(variables: UpdateProfessionalApplicationMutationVariables, options?: C): Promise<UpdateProfessionalApplicationMutation> {
      return requester<UpdateProfessionalApplicationMutation, UpdateProfessionalApplicationMutationVariables>(UpdateProfessionalApplicationDocument, variables, options)
    },
    verifyProfessionalApplication(variables: VerifyProfessionalApplicationMutationVariables, options?: C): Promise<VerifyProfessionalApplicationMutation> {
      return requester<VerifyProfessionalApplicationMutation, VerifyProfessionalApplicationMutationVariables>(VerifyProfessionalApplicationDocument, variables, options)
    },
    tradeTestProfessionalApplication(variables: TradeTestProfessionalApplicationMutationVariables, options?: C): Promise<TradeTestProfessionalApplicationMutation> {
      return requester<TradeTestProfessionalApplicationMutation, TradeTestProfessionalApplicationMutationVariables>(TradeTestProfessionalApplicationDocument, variables, options)
    },
    uploadFile(variables: UploadFileMutationVariables, options?: C): Promise<UploadFileMutation> {
      return requester<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, variables, options)
    },
    deleteFile(variables?: DeleteFileMutationVariables, options?: C): Promise<DeleteFileMutation> {
      return requester<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, variables, options)
    },
    leaveFeedback(variables: LeaveFeedbackMutationVariables, options?: C): Promise<LeaveFeedbackMutation> {
      return requester<LeaveFeedbackMutation, LeaveFeedbackMutationVariables>(LeaveFeedbackDocument, variables, options)
    },
    createGiftCardsBatch(variables?: CreateGiftCardsBatchMutationVariables, options?: C): Promise<CreateGiftCardsBatchMutation> {
      return requester<CreateGiftCardsBatchMutation, CreateGiftCardsBatchMutationVariables>(CreateGiftCardsBatchDocument, variables, options)
    },
    createBookingReport(variables?: CreateBookingReportMutationVariables, options?: C): Promise<CreateBookingReportMutation> {
      return requester<CreateBookingReportMutation, CreateBookingReportMutationVariables>(CreateBookingReportDocument, variables, options)
    },
    settings(variables?: SettingsQueryVariables, options?: C): Promise<SettingsQuery> {
      return requester<SettingsQuery, SettingsQueryVariables>(SettingsDocument, variables, options)
    },
    inAppMessages(variables: InAppMessagesQueryVariables, options?: C): Promise<InAppMessagesQuery> {
      return requester<InAppMessagesQuery, InAppMessagesQueryVariables>(InAppMessagesDocument, variables, options)
    },
    inAppMessage(variables: InAppMessageQueryVariables, options?: C): Promise<InAppMessageQuery> {
      return requester<InAppMessageQuery, InAppMessageQueryVariables>(InAppMessageDocument, variables, options)
    },
  }
}
export type Sdk = ReturnType<typeof getSdk>;